
      var $parcel$global = globalThis;
    'use strict';
var $74f0d4f55754f456$exports = {};
'use strict';
var $6e7d6a9e7ea450e0$exports = {};
'use strict';
$6e7d6a9e7ea450e0$exports = function(exec) {
    try {
        return !!exec();
    } catch (error) {
        return true;
    }
};


// Detect IE8's incomplete defineProperty implementation
$74f0d4f55754f456$exports = !$6e7d6a9e7ea450e0$exports(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty({}, 1, {
        get: function() {
            return 7;
        }
    })[1] !== 7;
});


var $ae47501853b7234f$exports = {};
'use strict';
var $2acd58bdf36af797$exports = {};
'use strict';
var $29c0e0d0b39162fc$exports = {};
'use strict';
var $5a4f91dfcb2fd699$exports = {};
'use strict';

$5a4f91dfcb2fd699$exports = !$6e7d6a9e7ea450e0$exports(function() {
    // eslint-disable-next-line es/no-function-prototype-bind -- safe
    var test = (function() {}).bind();
    // eslint-disable-next-line no-prototype-builtins -- safe
    return typeof test != 'function' || test.hasOwnProperty('prototype');
});


var $29c0e0d0b39162fc$var$FunctionPrototype = Function.prototype;
var $29c0e0d0b39162fc$var$call = $29c0e0d0b39162fc$var$FunctionPrototype.call;
// eslint-disable-next-line es/no-function-prototype-bind -- safe
var $29c0e0d0b39162fc$var$uncurryThisWithBind = $5a4f91dfcb2fd699$exports && $29c0e0d0b39162fc$var$FunctionPrototype.bind.bind($29c0e0d0b39162fc$var$call, $29c0e0d0b39162fc$var$call);
$29c0e0d0b39162fc$exports = $5a4f91dfcb2fd699$exports ? $29c0e0d0b39162fc$var$uncurryThisWithBind : function(fn) {
    return function() {
        return $29c0e0d0b39162fc$var$call.apply(fn, arguments);
    };
};



var $a195358de3a3707f$exports = {};
'use strict';
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot
var $a195358de3a3707f$var$documentAll = typeof document == 'object' && document.all;
// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
// eslint-disable-next-line unicorn/no-typeof-undefined -- required for testing
$a195358de3a3707f$exports = typeof $a195358de3a3707f$var$documentAll == 'undefined' && $a195358de3a3707f$var$documentAll !== undefined ? function(argument) {
    return typeof argument == 'function' || argument === $a195358de3a3707f$var$documentAll;
} : function(argument) {
    return typeof argument == 'function';
};


var $86dc347eeebd8975$exports = {};
'use strict';

var $d2ccfd3d2b87b12a$exports = {};
'use strict';
var $9b0f7c5f40b86f57$exports = {};
'use strict';
var $58ef6235aab53814$exports = {};
'use strict';
// we can't use just `it == null` since of `document.all` special case
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
$58ef6235aab53814$exports = function(it) {
    return it === null || it === undefined;
};


var $9b0f7c5f40b86f57$var$$TypeError = TypeError;
// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
$9b0f7c5f40b86f57$exports = function(it) {
    if ($58ef6235aab53814$exports(it)) throw new $9b0f7c5f40b86f57$var$$TypeError("Can't call method on " + it);
    return it;
};


var $d2ccfd3d2b87b12a$var$$Object = Object;
// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
$d2ccfd3d2b87b12a$exports = function(argument) {
    return $d2ccfd3d2b87b12a$var$$Object($9b0f7c5f40b86f57$exports(argument));
};


var $86dc347eeebd8975$var$hasOwnProperty = $29c0e0d0b39162fc$exports({}.hasOwnProperty);
// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es/no-object-hasown -- safe
$86dc347eeebd8975$exports = Object.hasOwn || function hasOwn(it, key) {
    return $86dc347eeebd8975$var$hasOwnProperty($d2ccfd3d2b87b12a$exports(it), key);
};



var $c05dc8fd1c3d9cfa$exports = {};
'use strict';


var $c05dc8fd1c3d9cfa$var$FunctionPrototype = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $c05dc8fd1c3d9cfa$var$getDescriptor = $74f0d4f55754f456$exports && Object.getOwnPropertyDescriptor;
var $c05dc8fd1c3d9cfa$var$EXISTS = $86dc347eeebd8975$exports($c05dc8fd1c3d9cfa$var$FunctionPrototype, 'name');
// additional protection from minified / mangled / dropped function names
var $c05dc8fd1c3d9cfa$var$PROPER = $c05dc8fd1c3d9cfa$var$EXISTS && (function something() {}).name === 'something';
var $c05dc8fd1c3d9cfa$var$CONFIGURABLE = $c05dc8fd1c3d9cfa$var$EXISTS && (!$74f0d4f55754f456$exports || $74f0d4f55754f456$exports && $c05dc8fd1c3d9cfa$var$getDescriptor($c05dc8fd1c3d9cfa$var$FunctionPrototype, 'name').configurable);
$c05dc8fd1c3d9cfa$exports = {
    EXISTS: $c05dc8fd1c3d9cfa$var$EXISTS,
    PROPER: $c05dc8fd1c3d9cfa$var$PROPER,
    CONFIGURABLE: $c05dc8fd1c3d9cfa$var$CONFIGURABLE
};


var $2acd58bdf36af797$require$CONFIGURABLE_FUNCTION_NAME = $c05dc8fd1c3d9cfa$exports.CONFIGURABLE;
var $d81a78ad01982ea5$exports = {};
'use strict';


var $455b59ef1bda8ac5$exports = {};
'use strict';
var $c004c15603d5f4b4$exports = {};
'use strict';
$c004c15603d5f4b4$exports = false;


var $2390c2ea2367eaf8$exports = {};
'use strict';
var $2390c2ea2367eaf8$var$check = function(it) {
    return it && it.Math === Math && it;
};
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
$2390c2ea2367eaf8$exports = // eslint-disable-next-line es/no-global-this -- safe
$2390c2ea2367eaf8$var$check(typeof globalThis == 'object' && globalThis) || $2390c2ea2367eaf8$var$check(typeof window == 'object' && window) || // eslint-disable-next-line no-restricted-globals -- safe
$2390c2ea2367eaf8$var$check(typeof self == 'object' && self) || $2390c2ea2367eaf8$var$check(typeof $parcel$global == 'object' && $parcel$global) || $2390c2ea2367eaf8$var$check(typeof $2390c2ea2367eaf8$exports == 'object' && $2390c2ea2367eaf8$exports) || // eslint-disable-next-line no-new-func -- fallback
function() {
    return this;
}() || Function('return this')();


var $5d429711ac477c5c$exports = {};
'use strict';

// eslint-disable-next-line es/no-object-defineproperty -- safe
var $5d429711ac477c5c$var$defineProperty = Object.defineProperty;
$5d429711ac477c5c$exports = function(key, value) {
    try {
        $5d429711ac477c5c$var$defineProperty($2390c2ea2367eaf8$exports, key, {
            value: value,
            configurable: true,
            writable: true
        });
    } catch (error) {
        $2390c2ea2367eaf8$exports[key] = value;
    }
    return value;
};


var $455b59ef1bda8ac5$var$SHARED = '__core-js_shared__';
var $455b59ef1bda8ac5$var$store = $455b59ef1bda8ac5$exports = $2390c2ea2367eaf8$exports[$455b59ef1bda8ac5$var$SHARED] || $5d429711ac477c5c$exports($455b59ef1bda8ac5$var$SHARED, {});
($455b59ef1bda8ac5$var$store.versions || ($455b59ef1bda8ac5$var$store.versions = [])).push({
    version: '3.47.0',
    mode: $c004c15603d5f4b4$exports ? 'pure' : 'global',
    copyright: "\xa9 2014-2025 Denis Pushkarev (zloirock.ru), 2025 CoreJS Company (core-js.io)",
    license: 'https://github.com/zloirock/core-js/blob/v3.47.0/LICENSE',
    source: 'https://github.com/zloirock/core-js'
});


var $d81a78ad01982ea5$var$functionToString = $29c0e0d0b39162fc$exports(Function.toString);
// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!$a195358de3a3707f$exports($455b59ef1bda8ac5$exports.inspectSource)) $455b59ef1bda8ac5$exports.inspectSource = function(it) {
    return $d81a78ad01982ea5$var$functionToString(it);
};
$d81a78ad01982ea5$exports = $455b59ef1bda8ac5$exports.inspectSource;


var $e9143c7b199430bf$exports = {};
'use strict';
var $6a8962ad7f723af0$exports = {};
'use strict';


var $6a8962ad7f723af0$var$WeakMap = $2390c2ea2367eaf8$exports.WeakMap;
$6a8962ad7f723af0$exports = $a195358de3a3707f$exports($6a8962ad7f723af0$var$WeakMap) && /native code/.test(String($6a8962ad7f723af0$var$WeakMap));



var $2837467ac05ffe63$exports = {};
'use strict';

$2837467ac05ffe63$exports = function(it) {
    return typeof it == 'object' ? it !== null : $a195358de3a3707f$exports(it);
};


var $8411c9e4648069f2$exports = {};
'use strict';

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
var $13ec28f78a282d57$export$2d1720544b23b823;
'use strict';

var $8e8fe6159d021185$exports = {};
'use strict';


var $f2e09b0fed095225$exports = {};
'use strict';


var $f2e09b0fed095225$var$document = $2390c2ea2367eaf8$exports.document;
// typeof document.createElement is 'object' in old IE
var $f2e09b0fed095225$var$EXISTS = $2837467ac05ffe63$exports($f2e09b0fed095225$var$document) && $2837467ac05ffe63$exports($f2e09b0fed095225$var$document.createElement);
$f2e09b0fed095225$exports = function(it) {
    return $f2e09b0fed095225$var$EXISTS ? $f2e09b0fed095225$var$document.createElement(it) : {};
};


// Thanks to IE8 for its funny defineProperty
$8e8fe6159d021185$exports = !$74f0d4f55754f456$exports && !$6e7d6a9e7ea450e0$exports(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty($f2e09b0fed095225$exports('div'), 'a', {
        get: function() {
            return 7;
        }
    }).a !== 7;
});


var $ebaddee3e75fe2a2$exports = {};
'use strict';


// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
$ebaddee3e75fe2a2$exports = $74f0d4f55754f456$exports && $6e7d6a9e7ea450e0$exports(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty(function() {}, 'prototype', {
        value: 42,
        writable: false
    }).prototype !== 42;
});


var $e61e9bf3b808e3f2$exports = {};
'use strict';

var $e61e9bf3b808e3f2$var$$String = String;
var $e61e9bf3b808e3f2$var$$TypeError = TypeError;
// `Assert: Type(argument) is Object`
$e61e9bf3b808e3f2$exports = function(argument) {
    if ($2837467ac05ffe63$exports(argument)) return argument;
    throw new $e61e9bf3b808e3f2$var$$TypeError($e61e9bf3b808e3f2$var$$String(argument) + ' is not an object');
};


var $4e865622204eb75c$exports = {};
'use strict';
var $58cdfe8ccc4cda08$exports = {};
'use strict';
var $d43568f6a768ada8$exports = {};
'use strict';

var $d43568f6a768ada8$var$call = Function.prototype.call;
// eslint-disable-next-line es/no-function-prototype-bind -- safe
$d43568f6a768ada8$exports = $5a4f91dfcb2fd699$exports ? $d43568f6a768ada8$var$call.bind($d43568f6a768ada8$var$call) : function() {
    return $d43568f6a768ada8$var$call.apply($d43568f6a768ada8$var$call, arguments);
};



var $c755a21533f8e6d5$exports = {};
'use strict';
var $17c1b0c7cd8c9e43$exports = {};
'use strict';


var $17c1b0c7cd8c9e43$var$aFunction = function(argument) {
    return $a195358de3a3707f$exports(argument) ? argument : undefined;
};
$17c1b0c7cd8c9e43$exports = function(namespace, method) {
    return arguments.length < 2 ? $17c1b0c7cd8c9e43$var$aFunction($2390c2ea2367eaf8$exports[namespace]) : $2390c2ea2367eaf8$exports[namespace] && $2390c2ea2367eaf8$exports[namespace][method];
};



var $85f0a5f6f6ac0684$exports = {};
'use strict';

$85f0a5f6f6ac0684$exports = $29c0e0d0b39162fc$exports({}.isPrototypeOf);


var $690f29fb98d2fbba$exports = {};
'use strict';
var $9c57fd1a1c5e54dc$exports = {};
'use strict';
var $43f86df0905c2fbd$exports = {};
'use strict';

var $50c2fc656abf0e1e$exports = {};
'use strict';

var $50c2fc656abf0e1e$var$navigator = $2390c2ea2367eaf8$exports.navigator;
var $50c2fc656abf0e1e$var$userAgent = $50c2fc656abf0e1e$var$navigator && $50c2fc656abf0e1e$var$navigator.userAgent;
$50c2fc656abf0e1e$exports = $50c2fc656abf0e1e$var$userAgent ? String($50c2fc656abf0e1e$var$userAgent) : '';


var $43f86df0905c2fbd$var$process = $2390c2ea2367eaf8$exports.process;
var $43f86df0905c2fbd$var$Deno = $2390c2ea2367eaf8$exports.Deno;
var $43f86df0905c2fbd$var$versions = $43f86df0905c2fbd$var$process && $43f86df0905c2fbd$var$process.versions || $43f86df0905c2fbd$var$Deno && $43f86df0905c2fbd$var$Deno.version;
var $43f86df0905c2fbd$var$v8 = $43f86df0905c2fbd$var$versions && $43f86df0905c2fbd$var$versions.v8;
var $43f86df0905c2fbd$var$match, $43f86df0905c2fbd$var$version;
if ($43f86df0905c2fbd$var$v8) {
    $43f86df0905c2fbd$var$match = $43f86df0905c2fbd$var$v8.split('.');
    // in old Chrome, versions of V8 isn't V8 = Chrome / 10
    // but their correct versions are not interesting for us
    $43f86df0905c2fbd$var$version = $43f86df0905c2fbd$var$match[0] > 0 && $43f86df0905c2fbd$var$match[0] < 4 ? 1 : +($43f86df0905c2fbd$var$match[0] + $43f86df0905c2fbd$var$match[1]);
}
// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!$43f86df0905c2fbd$var$version && $50c2fc656abf0e1e$exports) {
    $43f86df0905c2fbd$var$match = $50c2fc656abf0e1e$exports.match(/Edge\/(\d+)/);
    if (!$43f86df0905c2fbd$var$match || $43f86df0905c2fbd$var$match[1] >= 74) {
        $43f86df0905c2fbd$var$match = $50c2fc656abf0e1e$exports.match(/Chrome\/(\d+)/);
        if ($43f86df0905c2fbd$var$match) $43f86df0905c2fbd$var$version = +$43f86df0905c2fbd$var$match[1];
    }
}
$43f86df0905c2fbd$exports = $43f86df0905c2fbd$var$version;




var $9c57fd1a1c5e54dc$var$$String = $2390c2ea2367eaf8$exports.String;
// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
$9c57fd1a1c5e54dc$exports = !!Object.getOwnPropertySymbols && !$6e7d6a9e7ea450e0$exports(function() {
    var symbol = Symbol('symbol detection');
    // Chrome 38 Symbol has incorrect toString conversion
    // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
    // nb: Do not call `String` directly to avoid this being optimized out to `symbol+''` which will,
    // of course, fail.
    return !$9c57fd1a1c5e54dc$var$$String(symbol) || !(Object(symbol) instanceof Symbol) || // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && $43f86df0905c2fbd$exports && $43f86df0905c2fbd$exports < 41;
});


$690f29fb98d2fbba$exports = $9c57fd1a1c5e54dc$exports && !Symbol.sham && typeof Symbol.iterator == 'symbol';


var $c755a21533f8e6d5$var$$Object = Object;
$c755a21533f8e6d5$exports = $690f29fb98d2fbba$exports ? function(it) {
    return typeof it == 'symbol';
} : function(it) {
    var $Symbol = $17c1b0c7cd8c9e43$exports('Symbol');
    return $a195358de3a3707f$exports($Symbol) && $85f0a5f6f6ac0684$exports($Symbol.prototype, $c755a21533f8e6d5$var$$Object(it));
};


var $f13e4d6bf5303651$exports = {};
'use strict';
var $9e0e473f167dc60f$exports = {};
'use strict';

var $d8426ad630ed50f9$exports = {};
'use strict';
var $d8426ad630ed50f9$var$$String = String;
$d8426ad630ed50f9$exports = function(argument) {
    try {
        return $d8426ad630ed50f9$var$$String(argument);
    } catch (error) {
        return 'Object';
    }
};


var $9e0e473f167dc60f$var$$TypeError = TypeError;
// `Assert: IsCallable(argument) is true`
$9e0e473f167dc60f$exports = function(argument) {
    if ($a195358de3a3707f$exports(argument)) return argument;
    throw new $9e0e473f167dc60f$var$$TypeError($d8426ad630ed50f9$exports(argument) + ' is not a function');
};



// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
$f13e4d6bf5303651$exports = function(V, P) {
    var func = V[P];
    return $58ef6235aab53814$exports(func) ? undefined : $9e0e473f167dc60f$exports(func);
};


var $6960c110fb7213c8$exports = {};
'use strict';



var $6960c110fb7213c8$var$$TypeError = TypeError;
// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
$6960c110fb7213c8$exports = function(input, pref) {
    var fn, val;
    if (pref === 'string' && $a195358de3a3707f$exports(fn = input.toString) && !$2837467ac05ffe63$exports(val = $d43568f6a768ada8$exports(fn, input))) return val;
    if ($a195358de3a3707f$exports(fn = input.valueOf) && !$2837467ac05ffe63$exports(val = $d43568f6a768ada8$exports(fn, input))) return val;
    if (pref !== 'string' && $a195358de3a3707f$exports(fn = input.toString) && !$2837467ac05ffe63$exports(val = $d43568f6a768ada8$exports(fn, input))) return val;
    throw new $6960c110fb7213c8$var$$TypeError("Can't convert object to primitive value");
};


var $115c96fd2c842704$exports = {};
'use strict';

var $95e7fb0c754b13e0$exports = {};
'use strict';

$95e7fb0c754b13e0$exports = function(key, value) {
    return $455b59ef1bda8ac5$exports[key] || ($455b59ef1bda8ac5$exports[key] = value || {});
};



var $24d0340ce16b89d4$exports = {};
'use strict';

var $24d0340ce16b89d4$var$id = 0;
var $24d0340ce16b89d4$var$postfix = Math.random();
var $24d0340ce16b89d4$var$toString = $29c0e0d0b39162fc$exports(1.1.toString);
$24d0340ce16b89d4$exports = function(key) {
    return 'Symbol(' + (key === undefined ? '' : key) + ')_' + $24d0340ce16b89d4$var$toString(++$24d0340ce16b89d4$var$id + $24d0340ce16b89d4$var$postfix, 36);
};




var $115c96fd2c842704$var$Symbol = $2390c2ea2367eaf8$exports.Symbol;
var $115c96fd2c842704$var$WellKnownSymbolsStore = $95e7fb0c754b13e0$exports('wks');
var $115c96fd2c842704$var$createWellKnownSymbol = $690f29fb98d2fbba$exports ? $115c96fd2c842704$var$Symbol['for'] || $115c96fd2c842704$var$Symbol : $115c96fd2c842704$var$Symbol && $115c96fd2c842704$var$Symbol.withoutSetter || $24d0340ce16b89d4$exports;
$115c96fd2c842704$exports = function(name) {
    if (!$86dc347eeebd8975$exports($115c96fd2c842704$var$WellKnownSymbolsStore, name)) $115c96fd2c842704$var$WellKnownSymbolsStore[name] = $9c57fd1a1c5e54dc$exports && $86dc347eeebd8975$exports($115c96fd2c842704$var$Symbol, name) ? $115c96fd2c842704$var$Symbol[name] : $115c96fd2c842704$var$createWellKnownSymbol('Symbol.' + name);
    return $115c96fd2c842704$var$WellKnownSymbolsStore[name];
};


var $58cdfe8ccc4cda08$var$$TypeError = TypeError;
var $58cdfe8ccc4cda08$var$TO_PRIMITIVE = $115c96fd2c842704$exports('toPrimitive');
// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
$58cdfe8ccc4cda08$exports = function(input, pref) {
    if (!$2837467ac05ffe63$exports(input) || $c755a21533f8e6d5$exports(input)) return input;
    var exoticToPrim = $f13e4d6bf5303651$exports(input, $58cdfe8ccc4cda08$var$TO_PRIMITIVE);
    var result;
    if (exoticToPrim) {
        if (pref === undefined) pref = 'default';
        result = $d43568f6a768ada8$exports(exoticToPrim, input, pref);
        if (!$2837467ac05ffe63$exports(result) || $c755a21533f8e6d5$exports(result)) return result;
        throw new $58cdfe8ccc4cda08$var$$TypeError("Can't convert object to primitive value");
    }
    if (pref === undefined) pref = 'number';
    return $6960c110fb7213c8$exports(input, pref);
};



// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
$4e865622204eb75c$exports = function(argument) {
    var key = $58cdfe8ccc4cda08$exports(argument, 'string');
    return $c755a21533f8e6d5$exports(key) ? key : key + '';
};


var $13ec28f78a282d57$var$$TypeError = TypeError;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $13ec28f78a282d57$var$$defineProperty = Object.defineProperty;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $13ec28f78a282d57$var$$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $13ec28f78a282d57$var$ENUMERABLE = 'enumerable';
var $13ec28f78a282d57$var$CONFIGURABLE = 'configurable';
var $13ec28f78a282d57$var$WRITABLE = 'writable';
$13ec28f78a282d57$export$2d1720544b23b823 = $74f0d4f55754f456$exports ? $ebaddee3e75fe2a2$exports ? function defineProperty(O, P, Attributes) {
    $e61e9bf3b808e3f2$exports(O);
    P = $4e865622204eb75c$exports(P);
    $e61e9bf3b808e3f2$exports(Attributes);
    if (typeof O === 'function' && P === 'prototype' && 'value' in Attributes && $13ec28f78a282d57$var$WRITABLE in Attributes && !Attributes[$13ec28f78a282d57$var$WRITABLE]) {
        var current = $13ec28f78a282d57$var$$getOwnPropertyDescriptor(O, P);
        if (current && current[$13ec28f78a282d57$var$WRITABLE]) {
            O[P] = Attributes.value;
            Attributes = {
                configurable: $13ec28f78a282d57$var$CONFIGURABLE in Attributes ? Attributes[$13ec28f78a282d57$var$CONFIGURABLE] : current[$13ec28f78a282d57$var$CONFIGURABLE],
                enumerable: $13ec28f78a282d57$var$ENUMERABLE in Attributes ? Attributes[$13ec28f78a282d57$var$ENUMERABLE] : current[$13ec28f78a282d57$var$ENUMERABLE],
                writable: false
            };
        }
    }
    return $13ec28f78a282d57$var$$defineProperty(O, P, Attributes);
} : $13ec28f78a282d57$var$$defineProperty : function defineProperty(O, P, Attributes) {
    $e61e9bf3b808e3f2$exports(O);
    P = $4e865622204eb75c$exports(P);
    $e61e9bf3b808e3f2$exports(Attributes);
    if ($8e8fe6159d021185$exports) try {
        return $13ec28f78a282d57$var$$defineProperty(O, P, Attributes);
    } catch (error) {}
    if ('get' in Attributes || 'set' in Attributes) throw new $13ec28f78a282d57$var$$TypeError('Accessors not supported');
    if ('value' in Attributes) O[P] = Attributes.value;
    return O;
};


var $6169b1cb48909cf3$exports = {};
'use strict';
$6169b1cb48909cf3$exports = function(bitmap, value) {
    return {
        enumerable: !(bitmap & 1),
        configurable: !(bitmap & 2),
        writable: !(bitmap & 4),
        value: value
    };
};


$8411c9e4648069f2$exports = $74f0d4f55754f456$exports ? function(object, key, value) {
    return $13ec28f78a282d57$export$2d1720544b23b823(object, key, $6169b1cb48909cf3$exports(1, value));
} : function(object, key, value) {
    object[key] = value;
    return object;
};




var $50e75d8f81e71806$exports = {};
'use strict';


var $50e75d8f81e71806$var$keys = $95e7fb0c754b13e0$exports('keys');
$50e75d8f81e71806$exports = function(key) {
    return $50e75d8f81e71806$var$keys[key] || ($50e75d8f81e71806$var$keys[key] = $24d0340ce16b89d4$exports(key));
};


var $964d66eaf5447ae9$exports = {};
'use strict';
$964d66eaf5447ae9$exports = {};


var $e9143c7b199430bf$var$OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
var $e9143c7b199430bf$var$TypeError = $2390c2ea2367eaf8$exports.TypeError;
var $e9143c7b199430bf$var$WeakMap = $2390c2ea2367eaf8$exports.WeakMap;
var $e9143c7b199430bf$var$set, $e9143c7b199430bf$var$get, $e9143c7b199430bf$var$has;
var $e9143c7b199430bf$var$enforce = function(it) {
    return $e9143c7b199430bf$var$has(it) ? $e9143c7b199430bf$var$get(it) : $e9143c7b199430bf$var$set(it, {});
};
var $e9143c7b199430bf$var$getterFor = function(TYPE) {
    return function(it) {
        var state;
        if (!$2837467ac05ffe63$exports(it) || (state = $e9143c7b199430bf$var$get(it)).type !== TYPE) throw new $e9143c7b199430bf$var$TypeError('Incompatible receiver, ' + TYPE + ' required');
        return state;
    };
};
if ($6a8962ad7f723af0$exports || $455b59ef1bda8ac5$exports.state) {
    var $e9143c7b199430bf$var$store = $455b59ef1bda8ac5$exports.state || ($455b59ef1bda8ac5$exports.state = new $e9143c7b199430bf$var$WeakMap());
    /* eslint-disable no-self-assign -- prototype methods protection */ $e9143c7b199430bf$var$store.get = $e9143c7b199430bf$var$store.get;
    $e9143c7b199430bf$var$store.has = $e9143c7b199430bf$var$store.has;
    $e9143c7b199430bf$var$store.set = $e9143c7b199430bf$var$store.set;
    /* eslint-enable no-self-assign -- prototype methods protection */ $e9143c7b199430bf$var$set = function(it, metadata) {
        if ($e9143c7b199430bf$var$store.has(it)) throw new $e9143c7b199430bf$var$TypeError($e9143c7b199430bf$var$OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        $e9143c7b199430bf$var$store.set(it, metadata);
        return metadata;
    };
    $e9143c7b199430bf$var$get = function(it) {
        return $e9143c7b199430bf$var$store.get(it) || {};
    };
    $e9143c7b199430bf$var$has = function(it) {
        return $e9143c7b199430bf$var$store.has(it);
    };
} else {
    var $e9143c7b199430bf$var$STATE = $50e75d8f81e71806$exports('state');
    $964d66eaf5447ae9$exports[$e9143c7b199430bf$var$STATE] = true;
    $e9143c7b199430bf$var$set = function(it, metadata) {
        if ($86dc347eeebd8975$exports(it, $e9143c7b199430bf$var$STATE)) throw new $e9143c7b199430bf$var$TypeError($e9143c7b199430bf$var$OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        $8411c9e4648069f2$exports(it, $e9143c7b199430bf$var$STATE, metadata);
        return metadata;
    };
    $e9143c7b199430bf$var$get = function(it) {
        return $86dc347eeebd8975$exports(it, $e9143c7b199430bf$var$STATE) ? it[$e9143c7b199430bf$var$STATE] : {};
    };
    $e9143c7b199430bf$var$has = function(it) {
        return $86dc347eeebd8975$exports(it, $e9143c7b199430bf$var$STATE);
    };
}
$e9143c7b199430bf$exports = {
    set: $e9143c7b199430bf$var$set,
    get: $e9143c7b199430bf$var$get,
    has: $e9143c7b199430bf$var$has,
    enforce: $e9143c7b199430bf$var$enforce,
    getterFor: $e9143c7b199430bf$var$getterFor
};


var $2acd58bdf36af797$var$enforceInternalState = $e9143c7b199430bf$exports.enforce;
var $2acd58bdf36af797$var$getInternalState = $e9143c7b199430bf$exports.get;
var $2acd58bdf36af797$var$$String = String;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $2acd58bdf36af797$var$defineProperty = Object.defineProperty;
var $2acd58bdf36af797$var$stringSlice = $29c0e0d0b39162fc$exports(''.slice);
var $2acd58bdf36af797$var$replace = $29c0e0d0b39162fc$exports(''.replace);
var $2acd58bdf36af797$var$join = $29c0e0d0b39162fc$exports([].join);
var $2acd58bdf36af797$var$CONFIGURABLE_LENGTH = $74f0d4f55754f456$exports && !$6e7d6a9e7ea450e0$exports(function() {
    return $2acd58bdf36af797$var$defineProperty(function() {}, 'length', {
        value: 8
    }).length !== 8;
});
var $2acd58bdf36af797$var$TEMPLATE = String(String).split('String');
var $2acd58bdf36af797$var$makeBuiltIn = $2acd58bdf36af797$exports = function(value, name, options) {
    if ($2acd58bdf36af797$var$stringSlice($2acd58bdf36af797$var$$String(name), 0, 7) === 'Symbol(') name = '[' + $2acd58bdf36af797$var$replace($2acd58bdf36af797$var$$String(name), /^Symbol\(([^)]*)\).*$/, '$1') + ']';
    if (options && options.getter) name = 'get ' + name;
    if (options && options.setter) name = 'set ' + name;
    if (!$86dc347eeebd8975$exports(value, 'name') || $2acd58bdf36af797$require$CONFIGURABLE_FUNCTION_NAME && value.name !== name) {
        if ($74f0d4f55754f456$exports) $2acd58bdf36af797$var$defineProperty(value, 'name', {
            value: name,
            configurable: true
        });
        else value.name = name;
    }
    if ($2acd58bdf36af797$var$CONFIGURABLE_LENGTH && options && $86dc347eeebd8975$exports(options, 'arity') && value.length !== options.arity) $2acd58bdf36af797$var$defineProperty(value, 'length', {
        value: options.arity
    });
    try {
        if (options && $86dc347eeebd8975$exports(options, 'constructor') && options.constructor) {
            if ($74f0d4f55754f456$exports) $2acd58bdf36af797$var$defineProperty(value, 'prototype', {
                writable: false
            });
        } else if (value.prototype) value.prototype = undefined;
    } catch (error) {}
    var state = $2acd58bdf36af797$var$enforceInternalState(value);
    if (!$86dc347eeebd8975$exports(state, 'source')) state.source = $2acd58bdf36af797$var$join($2acd58bdf36af797$var$TEMPLATE, typeof name == 'string' ? name : '');
    return value;
};
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
// eslint-disable-next-line no-extend-native -- required
Function.prototype.toString = $2acd58bdf36af797$var$makeBuiltIn(function toString() {
    return $a195358de3a3707f$exports(this) && $2acd58bdf36af797$var$getInternalState(this).source || $d81a78ad01982ea5$exports(this);
}, 'toString');



$ae47501853b7234f$exports = function(target, name, descriptor) {
    if (descriptor.get) $2acd58bdf36af797$exports(descriptor.get, name, {
        getter: true
    });
    if (descriptor.set) $2acd58bdf36af797$exports(descriptor.set, name, {
        setter: true
    });
    return $13ec28f78a282d57$export$2d1720544b23b823(target, name, descriptor);
};


var $26b2f2b5e9b440b3$exports = {};
'use strict';


// babel-minify and Closure Compiler transpiles RegExp('.', 'd') -> /./d and it causes SyntaxError
var $26b2f2b5e9b440b3$var$RegExp = $2390c2ea2367eaf8$exports.RegExp;
var $26b2f2b5e9b440b3$var$FLAGS_GETTER_IS_CORRECT = !$6e7d6a9e7ea450e0$exports(function() {
    var INDICES_SUPPORT = true;
    try {
        $26b2f2b5e9b440b3$var$RegExp('.', 'd');
    } catch (error) {
        INDICES_SUPPORT = false;
    }
    var O = {};
    // modern V8 bug
    var calls = '';
    var expected = INDICES_SUPPORT ? 'dgimsy' : 'gimsy';
    var addGetter = function(key, chr) {
        // eslint-disable-next-line es/no-object-defineproperty -- safe
        Object.defineProperty(O, key, {
            get: function() {
                calls += chr;
                return true;
            }
        });
    };
    var pairs = {
        dotAll: 's',
        global: 'g',
        ignoreCase: 'i',
        multiline: 'm',
        sticky: 'y'
    };
    if (INDICES_SUPPORT) pairs.hasIndices = 'd';
    for(var key in pairs)addGetter(key, pairs[key]);
    // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
    var result = Object.getOwnPropertyDescriptor($26b2f2b5e9b440b3$var$RegExp.prototype, 'flags').get.call(O);
    return result !== expected || calls !== expected;
});
$26b2f2b5e9b440b3$exports = {
    correct: $26b2f2b5e9b440b3$var$FLAGS_GETTER_IS_CORRECT
};


var $f6f42d090b0ab8e6$exports = {};
'use strict';

// `RegExp.prototype.flags` getter implementation
// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
$f6f42d090b0ab8e6$exports = function() {
    var that = $e61e9bf3b808e3f2$exports(this);
    var result = '';
    if (that.hasIndices) result += 'd';
    if (that.global) result += 'g';
    if (that.ignoreCase) result += 'i';
    if (that.multiline) result += 'm';
    if (that.dotAll) result += 's';
    if (that.unicode) result += 'u';
    if (that.unicodeSets) result += 'v';
    if (that.sticky) result += 'y';
    return result;
};


// `RegExp.prototype.flags` getter
// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
if ($74f0d4f55754f456$exports && !$26b2f2b5e9b440b3$exports.correct) {
    $ae47501853b7234f$exports(RegExp.prototype, 'flags', {
        configurable: true,
        get: $f6f42d090b0ab8e6$exports
    });
    $26b2f2b5e9b440b3$exports.correct = true;
}


'use strict';


var $3d8b979fdb57e48f$exports = {};
'use strict';
var $b04ebf1335fd6059$exports = {};
'use strict';
// eslint-disable-next-line es/no-typed-arrays -- safe
$b04ebf1335fd6059$exports = typeof ArrayBuffer != 'undefined' && typeof DataView != 'undefined';







var $a82ddf87eb5cfbba$exports = {};
'use strict';
var $b036debf286b9e11$exports = {};
'use strict';

var $b036debf286b9e11$var$TO_STRING_TAG = $115c96fd2c842704$exports('toStringTag');
var $b036debf286b9e11$var$test = {};
// eslint-disable-next-line unicorn/no-immediate-mutation -- ES3 syntax limitation
$b036debf286b9e11$var$test[$b036debf286b9e11$var$TO_STRING_TAG] = 'z';
$b036debf286b9e11$exports = String($b036debf286b9e11$var$test) === '[object z]';



var $c3911d62512312be$exports = {};
'use strict';

var $c3911d62512312be$var$toString = $29c0e0d0b39162fc$exports({}.toString);
var $c3911d62512312be$var$stringSlice = $29c0e0d0b39162fc$exports(''.slice);
$c3911d62512312be$exports = function(it) {
    return $c3911d62512312be$var$stringSlice($c3911d62512312be$var$toString(it), 8, -1);
};



var $a82ddf87eb5cfbba$var$TO_STRING_TAG = $115c96fd2c842704$exports('toStringTag');
var $a82ddf87eb5cfbba$var$$Object = Object;
// ES3 wrong here
var $a82ddf87eb5cfbba$var$CORRECT_ARGUMENTS = $c3911d62512312be$exports(function() {
    return arguments;
}()) === 'Arguments';
// fallback for IE11 Script Access Denied error
var $a82ddf87eb5cfbba$var$tryGet = function(it, key) {
    try {
        return it[key];
    } catch (error) {}
};
// getting tag from ES6+ `Object.prototype.toString`
$a82ddf87eb5cfbba$exports = $b036debf286b9e11$exports ? $c3911d62512312be$exports : function(it) {
    var O, tag, result;
    return it === undefined ? 'Undefined' : it === null ? 'Null' : typeof (tag = $a82ddf87eb5cfbba$var$tryGet(O = $a82ddf87eb5cfbba$var$$Object(it), $a82ddf87eb5cfbba$var$TO_STRING_TAG)) == 'string' ? tag : $a82ddf87eb5cfbba$var$CORRECT_ARGUMENTS ? $c3911d62512312be$exports(O) : (result = $c3911d62512312be$exports(O)) === 'Object' && $a195358de3a3707f$exports(O.callee) ? 'Arguments' : result;
};




var $bb1e9c5cd5b607ba$exports = {};
'use strict';




$bb1e9c5cd5b607ba$exports = function(O, key, value, options) {
    if (!options) options = {};
    var simple = options.enumerable;
    var name = options.name !== undefined ? options.name : key;
    if ($a195358de3a3707f$exports(value)) $2acd58bdf36af797$exports(value, name, options);
    if (options.global) {
        if (simple) O[key] = value;
        else $5d429711ac477c5c$exports(key, value);
    } else {
        try {
            if (!options.unsafe) delete O[key];
            else if (O[key]) simple = true;
        } catch (error) {}
        if (simple) O[key] = value;
        else $13ec28f78a282d57$export$2d1720544b23b823(O, key, {
            value: value,
            enumerable: false,
            configurable: !options.nonConfigurable,
            writable: !options.nonWritable
        });
    }
    return O;
};




var $acdeeb1735e20641$exports = {};
'use strict';




var $6cb7a8dbba67e230$exports = {};
'use strict';

$6cb7a8dbba67e230$exports = !$6e7d6a9e7ea450e0$exports(function() {
    function F() {}
    F.prototype.constructor = null;
    // eslint-disable-next-line es/no-object-getprototypeof -- required for testing
    return Object.getPrototypeOf(new F()) !== F.prototype;
});


var $acdeeb1735e20641$var$IE_PROTO = $50e75d8f81e71806$exports('IE_PROTO');
var $acdeeb1735e20641$var$$Object = Object;
var $acdeeb1735e20641$var$ObjectPrototype = $acdeeb1735e20641$var$$Object.prototype;
// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
// eslint-disable-next-line es/no-object-getprototypeof -- safe
$acdeeb1735e20641$exports = $6cb7a8dbba67e230$exports ? $acdeeb1735e20641$var$$Object.getPrototypeOf : function(O) {
    var object = $d2ccfd3d2b87b12a$exports(O);
    if ($86dc347eeebd8975$exports(object, $acdeeb1735e20641$var$IE_PROTO)) return object[$acdeeb1735e20641$var$IE_PROTO];
    var constructor = object.constructor;
    if ($a195358de3a3707f$exports(constructor) && object instanceof constructor) return constructor.prototype;
    return object instanceof $acdeeb1735e20641$var$$Object ? $acdeeb1735e20641$var$ObjectPrototype : null;
};


var $ef906d0724089621$exports = {};
'use strict';
var $b8382bafbbe9e076$exports = {};
'use strict';


$b8382bafbbe9e076$exports = function(object, key, method) {
    try {
        // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
        return $29c0e0d0b39162fc$exports($9e0e473f167dc60f$exports(Object.getOwnPropertyDescriptor(object, key)[method]));
    } catch (error) {}
};




var $ded4f13e8eabefb1$exports = {};
'use strict';
var $6c4e014dc264c0ae$exports = {};
'use strict';

$6c4e014dc264c0ae$exports = function(argument) {
    return $2837467ac05ffe63$exports(argument) || argument === null;
};


var $ded4f13e8eabefb1$var$$String = String;
var $ded4f13e8eabefb1$var$$TypeError = TypeError;
$ded4f13e8eabefb1$exports = function(argument) {
    if ($6c4e014dc264c0ae$exports(argument)) return argument;
    throw new $ded4f13e8eabefb1$var$$TypeError("Can't set " + $ded4f13e8eabefb1$var$$String(argument) + ' as a prototype');
};


// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es/no-object-setprototypeof -- safe
$ef906d0724089621$exports = Object.setPrototypeOf || ('__proto__' in {} ? function() {
    var CORRECT_SETTER = false;
    var test = {};
    var setter;
    try {
        setter = $b8382bafbbe9e076$exports(Object.prototype, '__proto__', 'set');
        setter(test, []);
        CORRECT_SETTER = test instanceof Array;
    } catch (error) {}
    return function setPrototypeOf(O, proto) {
        $9b0f7c5f40b86f57$exports(O);
        $ded4f13e8eabefb1$exports(proto);
        if (!$2837467ac05ffe63$exports(O)) return O;
        if (CORRECT_SETTER) setter(O, proto);
        else O.__proto__ = proto;
        return O;
    };
}() : undefined);





var $3d8b979fdb57e48f$var$enforceInternalState = $e9143c7b199430bf$exports.enforce;
var $3d8b979fdb57e48f$var$getInternalState = $e9143c7b199430bf$exports.get;
var $3d8b979fdb57e48f$var$Int8Array = $2390c2ea2367eaf8$exports.Int8Array;
var $3d8b979fdb57e48f$var$Int8ArrayPrototype = $3d8b979fdb57e48f$var$Int8Array && $3d8b979fdb57e48f$var$Int8Array.prototype;
var $3d8b979fdb57e48f$var$Uint8ClampedArray = $2390c2ea2367eaf8$exports.Uint8ClampedArray;
var $3d8b979fdb57e48f$var$Uint8ClampedArrayPrototype = $3d8b979fdb57e48f$var$Uint8ClampedArray && $3d8b979fdb57e48f$var$Uint8ClampedArray.prototype;
var $3d8b979fdb57e48f$var$TypedArray = $3d8b979fdb57e48f$var$Int8Array && $acdeeb1735e20641$exports($3d8b979fdb57e48f$var$Int8Array);
var $3d8b979fdb57e48f$var$TypedArrayPrototype = $3d8b979fdb57e48f$var$Int8ArrayPrototype && $acdeeb1735e20641$exports($3d8b979fdb57e48f$var$Int8ArrayPrototype);
var $3d8b979fdb57e48f$var$ObjectPrototype = Object.prototype;
var $3d8b979fdb57e48f$var$TypeError = $2390c2ea2367eaf8$exports.TypeError;
var $3d8b979fdb57e48f$var$TO_STRING_TAG = $115c96fd2c842704$exports('toStringTag');
var $3d8b979fdb57e48f$var$TYPED_ARRAY_TAG = $24d0340ce16b89d4$exports('TYPED_ARRAY_TAG');
var $3d8b979fdb57e48f$var$TYPED_ARRAY_CONSTRUCTOR = 'TypedArrayConstructor';
// Fixing native typed arrays in Opera Presto crashes the browser, see #595
var $3d8b979fdb57e48f$var$NATIVE_ARRAY_BUFFER_VIEWS = $b04ebf1335fd6059$exports && !!$ef906d0724089621$exports && $a82ddf87eb5cfbba$exports($2390c2ea2367eaf8$exports.opera) !== 'Opera';
var $3d8b979fdb57e48f$var$TYPED_ARRAY_TAG_REQUIRED = false;
var $3d8b979fdb57e48f$var$NAME, $3d8b979fdb57e48f$var$Constructor, $3d8b979fdb57e48f$var$Prototype;
var $3d8b979fdb57e48f$var$TypedArrayConstructorsList = {
    Int8Array: 1,
    Uint8Array: 1,
    Uint8ClampedArray: 1,
    Int16Array: 2,
    Uint16Array: 2,
    Int32Array: 4,
    Uint32Array: 4,
    Float32Array: 4,
    Float64Array: 8
};
var $3d8b979fdb57e48f$var$BigIntArrayConstructorsList = {
    BigInt64Array: 8,
    BigUint64Array: 8
};
var $3d8b979fdb57e48f$var$isView = function isView(it) {
    if (!$2837467ac05ffe63$exports(it)) return false;
    var klass = $a82ddf87eb5cfbba$exports(it);
    return klass === 'DataView' || $86dc347eeebd8975$exports($3d8b979fdb57e48f$var$TypedArrayConstructorsList, klass) || $86dc347eeebd8975$exports($3d8b979fdb57e48f$var$BigIntArrayConstructorsList, klass);
};
var $3d8b979fdb57e48f$var$getTypedArrayConstructor = function(it) {
    var proto = $acdeeb1735e20641$exports(it);
    if (!$2837467ac05ffe63$exports(proto)) return;
    var state = $3d8b979fdb57e48f$var$getInternalState(proto);
    return state && $86dc347eeebd8975$exports(state, $3d8b979fdb57e48f$var$TYPED_ARRAY_CONSTRUCTOR) ? state[$3d8b979fdb57e48f$var$TYPED_ARRAY_CONSTRUCTOR] : $3d8b979fdb57e48f$var$getTypedArrayConstructor(proto);
};
var $3d8b979fdb57e48f$var$isTypedArray = function(it) {
    if (!$2837467ac05ffe63$exports(it)) return false;
    var klass = $a82ddf87eb5cfbba$exports(it);
    return $86dc347eeebd8975$exports($3d8b979fdb57e48f$var$TypedArrayConstructorsList, klass) || $86dc347eeebd8975$exports($3d8b979fdb57e48f$var$BigIntArrayConstructorsList, klass);
};
var $3d8b979fdb57e48f$var$aTypedArray = function(it) {
    if ($3d8b979fdb57e48f$var$isTypedArray(it)) return it;
    throw new $3d8b979fdb57e48f$var$TypeError('Target is not a typed array');
};
var $3d8b979fdb57e48f$var$aTypedArrayConstructor = function(C) {
    if ($a195358de3a3707f$exports(C) && (!$ef906d0724089621$exports || $85f0a5f6f6ac0684$exports($3d8b979fdb57e48f$var$TypedArray, C))) return C;
    throw new $3d8b979fdb57e48f$var$TypeError($d8426ad630ed50f9$exports(C) + ' is not a typed array constructor');
};
var $3d8b979fdb57e48f$var$exportTypedArrayMethod = function(KEY, property, forced, options) {
    if (!$74f0d4f55754f456$exports) return;
    if (forced) for(var ARRAY in $3d8b979fdb57e48f$var$TypedArrayConstructorsList){
        var TypedArrayConstructor = $2390c2ea2367eaf8$exports[ARRAY];
        if (TypedArrayConstructor && $86dc347eeebd8975$exports(TypedArrayConstructor.prototype, KEY)) try {
            delete TypedArrayConstructor.prototype[KEY];
        } catch (error) {
            // old WebKit bug - some methods are non-configurable
            try {
                TypedArrayConstructor.prototype[KEY] = property;
            } catch (error2) {}
        }
    }
    if (!$3d8b979fdb57e48f$var$TypedArrayPrototype[KEY] || forced) $bb1e9c5cd5b607ba$exports($3d8b979fdb57e48f$var$TypedArrayPrototype, KEY, forced ? property : $3d8b979fdb57e48f$var$NATIVE_ARRAY_BUFFER_VIEWS && $3d8b979fdb57e48f$var$Int8ArrayPrototype[KEY] || property, options);
};
var $3d8b979fdb57e48f$var$exportTypedArrayStaticMethod = function(KEY, property, forced) {
    var ARRAY, TypedArrayConstructor;
    if (!$74f0d4f55754f456$exports) return;
    if ($ef906d0724089621$exports) {
        if (forced) for(ARRAY in $3d8b979fdb57e48f$var$TypedArrayConstructorsList){
            TypedArrayConstructor = $2390c2ea2367eaf8$exports[ARRAY];
            if (TypedArrayConstructor && $86dc347eeebd8975$exports(TypedArrayConstructor, KEY)) try {
                delete TypedArrayConstructor[KEY];
            } catch (error) {}
        }
        if (!$3d8b979fdb57e48f$var$TypedArray[KEY] || forced) // V8 ~ Chrome 49-50 `%TypedArray%` methods are non-writable non-configurable
        try {
            return $bb1e9c5cd5b607ba$exports($3d8b979fdb57e48f$var$TypedArray, KEY, forced ? property : $3d8b979fdb57e48f$var$NATIVE_ARRAY_BUFFER_VIEWS && $3d8b979fdb57e48f$var$TypedArray[KEY] || property);
        } catch (error) {}
        else return;
    }
    for(ARRAY in $3d8b979fdb57e48f$var$TypedArrayConstructorsList){
        TypedArrayConstructor = $2390c2ea2367eaf8$exports[ARRAY];
        if (TypedArrayConstructor && (!TypedArrayConstructor[KEY] || forced)) $bb1e9c5cd5b607ba$exports(TypedArrayConstructor, KEY, property);
    }
};
for($3d8b979fdb57e48f$var$NAME in $3d8b979fdb57e48f$var$TypedArrayConstructorsList){
    $3d8b979fdb57e48f$var$Constructor = $2390c2ea2367eaf8$exports[$3d8b979fdb57e48f$var$NAME];
    $3d8b979fdb57e48f$var$Prototype = $3d8b979fdb57e48f$var$Constructor && $3d8b979fdb57e48f$var$Constructor.prototype;
    if ($3d8b979fdb57e48f$var$Prototype) $3d8b979fdb57e48f$var$enforceInternalState($3d8b979fdb57e48f$var$Prototype)[$3d8b979fdb57e48f$var$TYPED_ARRAY_CONSTRUCTOR] = $3d8b979fdb57e48f$var$Constructor;
    else $3d8b979fdb57e48f$var$NATIVE_ARRAY_BUFFER_VIEWS = false;
}
for($3d8b979fdb57e48f$var$NAME in $3d8b979fdb57e48f$var$BigIntArrayConstructorsList){
    $3d8b979fdb57e48f$var$Constructor = $2390c2ea2367eaf8$exports[$3d8b979fdb57e48f$var$NAME];
    $3d8b979fdb57e48f$var$Prototype = $3d8b979fdb57e48f$var$Constructor && $3d8b979fdb57e48f$var$Constructor.prototype;
    if ($3d8b979fdb57e48f$var$Prototype) $3d8b979fdb57e48f$var$enforceInternalState($3d8b979fdb57e48f$var$Prototype)[$3d8b979fdb57e48f$var$TYPED_ARRAY_CONSTRUCTOR] = $3d8b979fdb57e48f$var$Constructor;
}
// WebKit bug - typed arrays constructors prototype is Object.prototype
if (!$3d8b979fdb57e48f$var$NATIVE_ARRAY_BUFFER_VIEWS || !$a195358de3a3707f$exports($3d8b979fdb57e48f$var$TypedArray) || $3d8b979fdb57e48f$var$TypedArray === Function.prototype) {
    // eslint-disable-next-line no-shadow -- safe
    $3d8b979fdb57e48f$var$TypedArray = function TypedArray() {
        throw new $3d8b979fdb57e48f$var$TypeError('Incorrect invocation');
    };
    if ($3d8b979fdb57e48f$var$NATIVE_ARRAY_BUFFER_VIEWS) {
        for($3d8b979fdb57e48f$var$NAME in $3d8b979fdb57e48f$var$TypedArrayConstructorsList)if ($2390c2ea2367eaf8$exports[$3d8b979fdb57e48f$var$NAME]) $ef906d0724089621$exports($2390c2ea2367eaf8$exports[$3d8b979fdb57e48f$var$NAME], $3d8b979fdb57e48f$var$TypedArray);
    }
}
if (!$3d8b979fdb57e48f$var$NATIVE_ARRAY_BUFFER_VIEWS || !$3d8b979fdb57e48f$var$TypedArrayPrototype || $3d8b979fdb57e48f$var$TypedArrayPrototype === $3d8b979fdb57e48f$var$ObjectPrototype) {
    $3d8b979fdb57e48f$var$TypedArrayPrototype = $3d8b979fdb57e48f$var$TypedArray.prototype;
    if ($3d8b979fdb57e48f$var$NATIVE_ARRAY_BUFFER_VIEWS) {
        for($3d8b979fdb57e48f$var$NAME in $3d8b979fdb57e48f$var$TypedArrayConstructorsList)if ($2390c2ea2367eaf8$exports[$3d8b979fdb57e48f$var$NAME]) $ef906d0724089621$exports($2390c2ea2367eaf8$exports[$3d8b979fdb57e48f$var$NAME].prototype, $3d8b979fdb57e48f$var$TypedArrayPrototype);
    }
}
// WebKit bug - one more object in Uint8ClampedArray prototype chain
if ($3d8b979fdb57e48f$var$NATIVE_ARRAY_BUFFER_VIEWS && $acdeeb1735e20641$exports($3d8b979fdb57e48f$var$Uint8ClampedArrayPrototype) !== $3d8b979fdb57e48f$var$TypedArrayPrototype) $ef906d0724089621$exports($3d8b979fdb57e48f$var$Uint8ClampedArrayPrototype, $3d8b979fdb57e48f$var$TypedArrayPrototype);
if ($74f0d4f55754f456$exports && !$86dc347eeebd8975$exports($3d8b979fdb57e48f$var$TypedArrayPrototype, $3d8b979fdb57e48f$var$TO_STRING_TAG)) {
    $3d8b979fdb57e48f$var$TYPED_ARRAY_TAG_REQUIRED = true;
    $ae47501853b7234f$exports($3d8b979fdb57e48f$var$TypedArrayPrototype, $3d8b979fdb57e48f$var$TO_STRING_TAG, {
        configurable: true,
        get: function() {
            return $2837467ac05ffe63$exports(this) ? this[$3d8b979fdb57e48f$var$TYPED_ARRAY_TAG] : undefined;
        }
    });
    for($3d8b979fdb57e48f$var$NAME in $3d8b979fdb57e48f$var$TypedArrayConstructorsList)if ($2390c2ea2367eaf8$exports[$3d8b979fdb57e48f$var$NAME]) $8411c9e4648069f2$exports($2390c2ea2367eaf8$exports[$3d8b979fdb57e48f$var$NAME], $3d8b979fdb57e48f$var$TYPED_ARRAY_TAG, $3d8b979fdb57e48f$var$NAME);
}
$3d8b979fdb57e48f$exports = {
    NATIVE_ARRAY_BUFFER_VIEWS: $3d8b979fdb57e48f$var$NATIVE_ARRAY_BUFFER_VIEWS,
    TYPED_ARRAY_TAG: $3d8b979fdb57e48f$var$TYPED_ARRAY_TAG_REQUIRED && $3d8b979fdb57e48f$var$TYPED_ARRAY_TAG,
    aTypedArray: $3d8b979fdb57e48f$var$aTypedArray,
    aTypedArrayConstructor: $3d8b979fdb57e48f$var$aTypedArrayConstructor,
    exportTypedArrayMethod: $3d8b979fdb57e48f$var$exportTypedArrayMethod,
    exportTypedArrayStaticMethod: $3d8b979fdb57e48f$var$exportTypedArrayStaticMethod,
    getTypedArrayConstructor: $3d8b979fdb57e48f$var$getTypedArrayConstructor,
    isView: $3d8b979fdb57e48f$var$isView,
    isTypedArray: $3d8b979fdb57e48f$var$isTypedArray,
    TypedArray: $3d8b979fdb57e48f$var$TypedArray,
    TypedArrayPrototype: $3d8b979fdb57e48f$var$TypedArrayPrototype
};


var $e10d40f4aab8dcca$exports = {};
'use strict';
var $dd2e849b350af962$exports = {};
'use strict';
var $2fea74955e819585$exports = {};
'use strict';
var $9b8fdd190464e150$exports = {};
'use strict';
var $9b8fdd190464e150$var$ceil = Math.ceil;
var $9b8fdd190464e150$var$floor = Math.floor;
// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es/no-math-trunc -- safe
$9b8fdd190464e150$exports = Math.trunc || function trunc(x) {
    var n = +x;
    return (n > 0 ? $9b8fdd190464e150$var$floor : $9b8fdd190464e150$var$ceil)(n);
};


// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
$2fea74955e819585$exports = function(argument) {
    var number = +argument;
    // eslint-disable-next-line no-self-compare -- NaN check
    return number !== number || number === 0 ? 0 : $9b8fdd190464e150$exports(number);
};


var $dd2e849b350af962$var$min = Math.min;
// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
$dd2e849b350af962$exports = function(argument) {
    var len = $2fea74955e819585$exports(argument);
    return len > 0 ? $dd2e849b350af962$var$min(len, 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};


// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
$e10d40f4aab8dcca$exports = function(obj) {
    return $dd2e849b350af962$exports(obj.length);
};


var $5356ff1f9ae94342$exports = {};
'use strict';
var $1e48b3af752ae04e$exports = {};
'use strict';

var $1e48b3af752ae04e$var$$RangeError = RangeError;
$1e48b3af752ae04e$exports = function(it) {
    var result = $2fea74955e819585$exports(it);
    if (result < 0) throw new $1e48b3af752ae04e$var$$RangeError("The argument can't be less than 0");
    return result;
};


var $5356ff1f9ae94342$var$$RangeError = RangeError;
$5356ff1f9ae94342$exports = function(it, BYTES) {
    var offset = $1e48b3af752ae04e$exports(it);
    if (offset % BYTES) throw new $5356ff1f9ae94342$var$$RangeError('Wrong offset');
    return offset;
};




var $5cf3fe33b6d8bbbd$var$RangeError = $2390c2ea2367eaf8$exports.RangeError;
var $5cf3fe33b6d8bbbd$var$Int8Array = $2390c2ea2367eaf8$exports.Int8Array;
var $5cf3fe33b6d8bbbd$var$Int8ArrayPrototype = $5cf3fe33b6d8bbbd$var$Int8Array && $5cf3fe33b6d8bbbd$var$Int8Array.prototype;
var $5cf3fe33b6d8bbbd$var$$set = $5cf3fe33b6d8bbbd$var$Int8ArrayPrototype && $5cf3fe33b6d8bbbd$var$Int8ArrayPrototype.set;
var $5cf3fe33b6d8bbbd$var$aTypedArray = $3d8b979fdb57e48f$exports.aTypedArray;
var $5cf3fe33b6d8bbbd$var$exportTypedArrayMethod = $3d8b979fdb57e48f$exports.exportTypedArrayMethod;
var $5cf3fe33b6d8bbbd$var$WORKS_WITH_OBJECTS_AND_GENERIC_ON_TYPED_ARRAYS = !$6e7d6a9e7ea450e0$exports(function() {
    // eslint-disable-next-line es/no-typed-arrays -- required for testing
    var array = new Uint8ClampedArray(2);
    $d43568f6a768ada8$exports($5cf3fe33b6d8bbbd$var$$set, array, {
        length: 1,
        0: 3
    }, 1);
    return array[1] !== 3;
});
// https://bugs.chromium.org/p/v8/issues/detail?id=11294 and other
var $5cf3fe33b6d8bbbd$var$TO_OBJECT_BUG = $5cf3fe33b6d8bbbd$var$WORKS_WITH_OBJECTS_AND_GENERIC_ON_TYPED_ARRAYS && $3d8b979fdb57e48f$exports.NATIVE_ARRAY_BUFFER_VIEWS && $6e7d6a9e7ea450e0$exports(function() {
    var array = new $5cf3fe33b6d8bbbd$var$Int8Array(2);
    array.set(1);
    array.set('2', 1);
    return array[0] !== 0 || array[1] !== 2;
});
// `%TypedArray%.prototype.set` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.set
$5cf3fe33b6d8bbbd$var$exportTypedArrayMethod('set', function set(arrayLike /* , offset */ ) {
    $5cf3fe33b6d8bbbd$var$aTypedArray(this);
    var offset = $5356ff1f9ae94342$exports(arguments.length > 1 ? arguments[1] : undefined, 1);
    var src = $d2ccfd3d2b87b12a$exports(arrayLike);
    if ($5cf3fe33b6d8bbbd$var$WORKS_WITH_OBJECTS_AND_GENERIC_ON_TYPED_ARRAYS) return $d43568f6a768ada8$exports($5cf3fe33b6d8bbbd$var$$set, this, src, offset);
    var length = this.length;
    var len = $e10d40f4aab8dcca$exports(src);
    var index = 0;
    if (len + offset > length) throw new $5cf3fe33b6d8bbbd$var$RangeError('Wrong length');
    while(index < len)this[offset + index] = src[index++];
}, !$5cf3fe33b6d8bbbd$var$WORKS_WITH_OBJECTS_AND_GENERIC_ON_TYPED_ARRAYS || $5cf3fe33b6d8bbbd$var$TO_OBJECT_BUG);


'use strict';
'use strict';
var $9238275af5270050$exports = {};
'use strict';

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
var $6bdc3f8e47e63590$export$2d1720544b23b823;
'use strict';


// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
var $2ca3ced35c303f3e$export$2d1720544b23b823;
'use strict';
var $2ca3ced35c303f3e$var$$propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $2ca3ced35c303f3e$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
// Nashorn ~ JDK8 bug
var $2ca3ced35c303f3e$var$NASHORN_BUG = $2ca3ced35c303f3e$var$getOwnPropertyDescriptor && !$2ca3ced35c303f3e$var$$propertyIsEnumerable.call({
    1: 2
}, 1);
$2ca3ced35c303f3e$export$2d1720544b23b823 = $2ca3ced35c303f3e$var$NASHORN_BUG ? function propertyIsEnumerable(V) {
    var descriptor = $2ca3ced35c303f3e$var$getOwnPropertyDescriptor(this, V);
    return !!descriptor && descriptor.enumerable;
} : $2ca3ced35c303f3e$var$$propertyIsEnumerable;



var $394b736b30227a7b$exports = {};
'use strict';
var $ea3b5aaf5dcdc984$exports = {};
'use strict';



var $ea3b5aaf5dcdc984$var$$Object = Object;
var $ea3b5aaf5dcdc984$var$split = $29c0e0d0b39162fc$exports(''.split);
// fallback for non-array-like ES3 and non-enumerable old V8 strings
$ea3b5aaf5dcdc984$exports = $6e7d6a9e7ea450e0$exports(function() {
    // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
    // eslint-disable-next-line no-prototype-builtins -- safe
    return !$ea3b5aaf5dcdc984$var$$Object('z').propertyIsEnumerable(0);
}) ? function(it) {
    return $c3911d62512312be$exports(it) === 'String' ? $ea3b5aaf5dcdc984$var$split(it, '') : $ea3b5aaf5dcdc984$var$$Object(it);
} : $ea3b5aaf5dcdc984$var$$Object;



$394b736b30227a7b$exports = function(it) {
    return $ea3b5aaf5dcdc984$exports($9b0f7c5f40b86f57$exports(it));
};





// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $6bdc3f8e47e63590$var$$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
$6bdc3f8e47e63590$export$2d1720544b23b823 = $74f0d4f55754f456$exports ? $6bdc3f8e47e63590$var$$getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
    O = $394b736b30227a7b$exports(O);
    P = $4e865622204eb75c$exports(P);
    if ($8e8fe6159d021185$exports) try {
        return $6bdc3f8e47e63590$var$$getOwnPropertyDescriptor(O, P);
    } catch (error) {}
    if ($86dc347eeebd8975$exports(O, P)) return $6169b1cb48909cf3$exports(!$d43568f6a768ada8$exports($2ca3ced35c303f3e$export$2d1720544b23b823, O, P), O[P]);
};


var $9238275af5270050$require$getOwnPropertyDescriptor = $6bdc3f8e47e63590$export$2d1720544b23b823;



var $5b17f46366231792$exports = {};
'use strict';

var $ae518c0b43e59f4d$exports = {};
'use strict';


// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
var $53548d4afe956386$export$2d1720544b23b823;
'use strict';
var $70677784bcd815e3$exports = {};
'use strict';



var $a2817150c03c34e1$exports = {};
'use strict';

var $5aec36a6bb9f68a6$exports = {};
'use strict';

var $5aec36a6bb9f68a6$var$max = Math.max;
var $5aec36a6bb9f68a6$var$min = Math.min;
// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
$5aec36a6bb9f68a6$exports = function(index, length) {
    var integer = $2fea74955e819585$exports(index);
    return integer < 0 ? $5aec36a6bb9f68a6$var$max(integer + length, 0) : $5aec36a6bb9f68a6$var$min(integer, length);
};



// `Array.prototype.{ indexOf, includes }` methods implementation
var $a2817150c03c34e1$var$createMethod = function(IS_INCLUDES) {
    return function($this, el, fromIndex) {
        var O = $394b736b30227a7b$exports($this);
        var length = $e10d40f4aab8dcca$exports(O);
        if (length === 0) return !IS_INCLUDES && -1;
        var index = $5aec36a6bb9f68a6$exports(fromIndex, length);
        var value;
        // Array#includes uses SameValueZero equality algorithm
        // eslint-disable-next-line no-self-compare -- NaN check
        if (IS_INCLUDES && el !== el) while(length > index){
            value = O[index++];
            // eslint-disable-next-line no-self-compare -- NaN check
            if (value !== value) return true;
        // Array#indexOf ignores holes, Array#includes - not
        }
        else for(; length > index; index++){
            if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
        }
        return !IS_INCLUDES && -1;
    };
};
$a2817150c03c34e1$exports = {
    // `Array.prototype.includes` method
    // https://tc39.es/ecma262/#sec-array.prototype.includes
    includes: $a2817150c03c34e1$var$createMethod(true),
    // `Array.prototype.indexOf` method
    // https://tc39.es/ecma262/#sec-array.prototype.indexof
    indexOf: $a2817150c03c34e1$var$createMethod(false)
};


var $70677784bcd815e3$require$indexOf = $a2817150c03c34e1$exports.indexOf;

var $70677784bcd815e3$var$push = $29c0e0d0b39162fc$exports([].push);
$70677784bcd815e3$exports = function(object, names) {
    var O = $394b736b30227a7b$exports(object);
    var i = 0;
    var result = [];
    var key;
    for(key in O)!$86dc347eeebd8975$exports($964d66eaf5447ae9$exports, key) && $86dc347eeebd8975$exports(O, key) && $70677784bcd815e3$var$push(result, key);
    // Don't enum bug & hidden keys
    while(names.length > i)if ($86dc347eeebd8975$exports(O, key = names[i++])) ~$70677784bcd815e3$require$indexOf(result, key) || $70677784bcd815e3$var$push(result, key);
    return result;
};


var $71756ea705037ab3$exports = {};
'use strict';
// IE8- don't enum bug keys
$71756ea705037ab3$exports = [
    'constructor',
    'hasOwnProperty',
    'isPrototypeOf',
    'propertyIsEnumerable',
    'toLocaleString',
    'toString',
    'valueOf'
];


var $53548d4afe956386$var$hiddenKeys = $71756ea705037ab3$exports.concat('length', 'prototype');
$53548d4afe956386$export$2d1720544b23b823 = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
    return $70677784bcd815e3$exports(O, $53548d4afe956386$var$hiddenKeys);
};


// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
var $d7fab3cd538bbf94$export$2d1720544b23b823;
'use strict';
$d7fab3cd538bbf94$export$2d1720544b23b823 = Object.getOwnPropertySymbols;



var $ae518c0b43e59f4d$var$concat = $29c0e0d0b39162fc$exports([].concat);
// all object keys, includes non-enumerable and symbols
$ae518c0b43e59f4d$exports = $17c1b0c7cd8c9e43$exports('Reflect', 'ownKeys') || function ownKeys(it) {
    var keys = $53548d4afe956386$export$2d1720544b23b823($e61e9bf3b808e3f2$exports(it));
    var getOwnPropertySymbols = $d7fab3cd538bbf94$export$2d1720544b23b823;
    return getOwnPropertySymbols ? $ae518c0b43e59f4d$var$concat(keys, getOwnPropertySymbols(it)) : keys;
};




$5b17f46366231792$exports = function(target, source, exceptions) {
    var keys = $ae518c0b43e59f4d$exports(source);
    var defineProperty = $13ec28f78a282d57$export$2d1720544b23b823;
    var getOwnPropertyDescriptor = $6bdc3f8e47e63590$export$2d1720544b23b823;
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        if (!$86dc347eeebd8975$exports(target, key) && !(exceptions && $86dc347eeebd8975$exports(exceptions, key))) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
};


var $9017fbd039a7bdc5$exports = {};
'use strict';


var $9017fbd039a7bdc5$var$replacement = /#|\.prototype\./;
var $9017fbd039a7bdc5$var$isForced = function(feature, detection) {
    var value = $9017fbd039a7bdc5$var$data[$9017fbd039a7bdc5$var$normalize(feature)];
    return value === $9017fbd039a7bdc5$var$POLYFILL ? true : value === $9017fbd039a7bdc5$var$NATIVE ? false : $a195358de3a3707f$exports(detection) ? $6e7d6a9e7ea450e0$exports(detection) : !!detection;
};
var $9017fbd039a7bdc5$var$normalize = $9017fbd039a7bdc5$var$isForced.normalize = function(string) {
    return String(string).replace($9017fbd039a7bdc5$var$replacement, '.').toLowerCase();
};
var $9017fbd039a7bdc5$var$data = $9017fbd039a7bdc5$var$isForced.data = {};
var $9017fbd039a7bdc5$var$NATIVE = $9017fbd039a7bdc5$var$isForced.NATIVE = 'N';
var $9017fbd039a7bdc5$var$POLYFILL = $9017fbd039a7bdc5$var$isForced.POLYFILL = 'P';
$9017fbd039a7bdc5$exports = $9017fbd039a7bdc5$var$isForced;


/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/ $9238275af5270050$exports = function(options, source) {
    var TARGET = options.target;
    var GLOBAL = options.global;
    var STATIC = options.stat;
    var FORCED, target, key, targetProperty, sourceProperty, descriptor;
    if (GLOBAL) target = $2390c2ea2367eaf8$exports;
    else if (STATIC) target = $2390c2ea2367eaf8$exports[TARGET] || $5d429711ac477c5c$exports(TARGET, {});
    else target = $2390c2ea2367eaf8$exports[TARGET] && $2390c2ea2367eaf8$exports[TARGET].prototype;
    if (target) for(key in source){
        sourceProperty = source[key];
        if (options.dontCallGetSet) {
            descriptor = $9238275af5270050$require$getOwnPropertyDescriptor(target, key);
            targetProperty = descriptor && descriptor.value;
        } else targetProperty = target[key];
        FORCED = $9017fbd039a7bdc5$exports(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
        // contained in target
        if (!FORCED && targetProperty !== undefined) {
            if (typeof sourceProperty == typeof targetProperty) continue;
            $5b17f46366231792$exports(sourceProperty, targetProperty);
        }
        // add a flag to not completely full polyfills
        if (options.sham || targetProperty && targetProperty.sham) $8411c9e4648069f2$exports(sourceProperty, 'sham', true);
        $bb1e9c5cd5b607ba$exports(target, key, sourceProperty, options);
    }
};



var $053708510ab93ee9$exports = {};
'use strict';

var $ef60a88fa6ec2ac7$exports = {};
'use strict';

var $ef60a88fa6ec2ac7$var$FunctionPrototype = Function.prototype;
var $ef60a88fa6ec2ac7$var$apply = $ef60a88fa6ec2ac7$var$FunctionPrototype.apply;
var $ef60a88fa6ec2ac7$var$call = $ef60a88fa6ec2ac7$var$FunctionPrototype.call;
// eslint-disable-next-line es/no-function-prototype-bind, es/no-reflect -- safe
$ef60a88fa6ec2ac7$exports = typeof Reflect == 'object' && Reflect.apply || ($5a4f91dfcb2fd699$exports ? $ef60a88fa6ec2ac7$var$call.bind($ef60a88fa6ec2ac7$var$apply) : function() {
    return $ef60a88fa6ec2ac7$var$call.apply($ef60a88fa6ec2ac7$var$apply, arguments);
});


var $e2ea99f696fd234d$exports = {};
'use strict';
var $5cb092d881fda978$exports = {};
'use strict';


$5cb092d881fda978$exports = function(fn) {
    // Nashorn bug:
    //   https://github.com/zloirock/core-js/issues/1128
    //   https://github.com/zloirock/core-js/issues/1130
    if ($c3911d62512312be$exports(fn) === 'Function') return $29c0e0d0b39162fc$exports(fn);
};




var $e2ea99f696fd234d$var$bind = $5cb092d881fda978$exports($5cb092d881fda978$exports.bind);
// optional / simple context binding
$e2ea99f696fd234d$exports = function(fn, that) {
    $9e0e473f167dc60f$exports(fn);
    return that === undefined ? fn : $5a4f91dfcb2fd699$exports ? $e2ea99f696fd234d$var$bind(fn, that) : function() {
        return fn.apply(that, arguments);
    };
};





var $dfe7cc303c4c1299$exports = {};
'use strict';

$dfe7cc303c4c1299$exports = $17c1b0c7cd8c9e43$exports('document', 'documentElement');


var $862bc4037f2ad95b$exports = {};
'use strict';

$862bc4037f2ad95b$exports = $29c0e0d0b39162fc$exports([].slice);



var $a7fcaf5fee29532d$exports = {};
'use strict';
var $a7fcaf5fee29532d$var$$TypeError = TypeError;
$a7fcaf5fee29532d$exports = function(passed, required) {
    if (passed < required) throw new $a7fcaf5fee29532d$var$$TypeError('Not enough arguments');
    return passed;
};


var $e042a9787a8f7f44$exports = {};
'use strict';

// eslint-disable-next-line redos/no-vulnerable -- safe
$e042a9787a8f7f44$exports = /(?:ipad|iphone|ipod).*applewebkit/i.test($50c2fc656abf0e1e$exports);


var $96bc5979bda7c627$exports = {};
'use strict';
var $66311f835b36ffa0$exports = {};
'use strict';



var $66311f835b36ffa0$var$userAgentStartsWith = function(string) {
    return $50c2fc656abf0e1e$exports.slice(0, string.length) === string;
};
$66311f835b36ffa0$exports = function() {
    if ($66311f835b36ffa0$var$userAgentStartsWith('Bun/')) return 'BUN';
    if ($66311f835b36ffa0$var$userAgentStartsWith('Cloudflare-Workers')) return 'CLOUDFLARE';
    if ($66311f835b36ffa0$var$userAgentStartsWith('Deno/')) return 'DENO';
    if ($66311f835b36ffa0$var$userAgentStartsWith('Node.js/')) return 'NODE';
    if ($2390c2ea2367eaf8$exports.Bun && typeof Bun.version == 'string') return 'BUN';
    if ($2390c2ea2367eaf8$exports.Deno && typeof Deno.version == 'object') return 'DENO';
    if ($c3911d62512312be$exports($2390c2ea2367eaf8$exports.process) === 'process') return 'NODE';
    if ($2390c2ea2367eaf8$exports.window && $2390c2ea2367eaf8$exports.document) return 'BROWSER';
    return 'REST';
}();


$96bc5979bda7c627$exports = $66311f835b36ffa0$exports === 'NODE';


var $053708510ab93ee9$var$set = $2390c2ea2367eaf8$exports.setImmediate;
var $053708510ab93ee9$var$clear = $2390c2ea2367eaf8$exports.clearImmediate;
var $053708510ab93ee9$var$process = $2390c2ea2367eaf8$exports.process;
var $053708510ab93ee9$var$Dispatch = $2390c2ea2367eaf8$exports.Dispatch;
var $053708510ab93ee9$var$Function = $2390c2ea2367eaf8$exports.Function;
var $053708510ab93ee9$var$MessageChannel = $2390c2ea2367eaf8$exports.MessageChannel;
var $053708510ab93ee9$var$String = $2390c2ea2367eaf8$exports.String;
var $053708510ab93ee9$var$counter = 0;
var $053708510ab93ee9$var$queue = {};
var $053708510ab93ee9$var$ONREADYSTATECHANGE = 'onreadystatechange';
var $053708510ab93ee9$var$$location, $053708510ab93ee9$var$defer, $053708510ab93ee9$var$channel, $053708510ab93ee9$var$port;
$6e7d6a9e7ea450e0$exports(function() {
    // Deno throws a ReferenceError on `location` access without `--location` flag
    $053708510ab93ee9$var$$location = $2390c2ea2367eaf8$exports.location;
});
var $053708510ab93ee9$var$run = function(id) {
    if ($86dc347eeebd8975$exports($053708510ab93ee9$var$queue, id)) {
        var fn = $053708510ab93ee9$var$queue[id];
        delete $053708510ab93ee9$var$queue[id];
        fn();
    }
};
var $053708510ab93ee9$var$runner = function(id) {
    return function() {
        $053708510ab93ee9$var$run(id);
    };
};
var $053708510ab93ee9$var$eventListener = function(event) {
    $053708510ab93ee9$var$run(event.data);
};
var $053708510ab93ee9$var$globalPostMessageDefer = function(id) {
    // old engines have not location.origin
    $2390c2ea2367eaf8$exports.postMessage($053708510ab93ee9$var$String(id), $053708510ab93ee9$var$$location.protocol + '//' + $053708510ab93ee9$var$$location.host);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!$053708510ab93ee9$var$set || !$053708510ab93ee9$var$clear) {
    $053708510ab93ee9$var$set = function setImmediate(handler) {
        $a7fcaf5fee29532d$exports(arguments.length, 1);
        var fn = $a195358de3a3707f$exports(handler) ? handler : $053708510ab93ee9$var$Function(handler);
        var args = $862bc4037f2ad95b$exports(arguments, 1);
        $053708510ab93ee9$var$queue[++$053708510ab93ee9$var$counter] = function() {
            $ef60a88fa6ec2ac7$exports(fn, undefined, args);
        };
        $053708510ab93ee9$var$defer($053708510ab93ee9$var$counter);
        return $053708510ab93ee9$var$counter;
    };
    $053708510ab93ee9$var$clear = function clearImmediate(id) {
        delete $053708510ab93ee9$var$queue[id];
    };
    // Node.js 0.8-
    if ($96bc5979bda7c627$exports) $053708510ab93ee9$var$defer = function(id) {
        $053708510ab93ee9$var$process.nextTick($053708510ab93ee9$var$runner(id));
    };
    else if ($053708510ab93ee9$var$Dispatch && $053708510ab93ee9$var$Dispatch.now) $053708510ab93ee9$var$defer = function(id) {
        $053708510ab93ee9$var$Dispatch.now($053708510ab93ee9$var$runner(id));
    };
    else if ($053708510ab93ee9$var$MessageChannel && !$e042a9787a8f7f44$exports) {
        $053708510ab93ee9$var$channel = new $053708510ab93ee9$var$MessageChannel();
        $053708510ab93ee9$var$port = $053708510ab93ee9$var$channel.port2;
        $053708510ab93ee9$var$channel.port1.onmessage = $053708510ab93ee9$var$eventListener;
        $053708510ab93ee9$var$defer = $e2ea99f696fd234d$exports($053708510ab93ee9$var$port.postMessage, $053708510ab93ee9$var$port);
    // Browsers with postMessage, skip WebWorkers
    // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
    } else if ($2390c2ea2367eaf8$exports.addEventListener && $a195358de3a3707f$exports($2390c2ea2367eaf8$exports.postMessage) && !$2390c2ea2367eaf8$exports.importScripts && $053708510ab93ee9$var$$location && $053708510ab93ee9$var$$location.protocol !== 'file:' && !$6e7d6a9e7ea450e0$exports($053708510ab93ee9$var$globalPostMessageDefer)) {
        $053708510ab93ee9$var$defer = $053708510ab93ee9$var$globalPostMessageDefer;
        $2390c2ea2367eaf8$exports.addEventListener('message', $053708510ab93ee9$var$eventListener, false);
    // IE8-
    } else if ($053708510ab93ee9$var$ONREADYSTATECHANGE in $f2e09b0fed095225$exports('script')) $053708510ab93ee9$var$defer = function(id) {
        $dfe7cc303c4c1299$exports.appendChild($f2e09b0fed095225$exports('script'))[$053708510ab93ee9$var$ONREADYSTATECHANGE] = function() {
            $dfe7cc303c4c1299$exports.removeChild(this);
            $053708510ab93ee9$var$run(id);
        };
    };
    else $053708510ab93ee9$var$defer = function(id) {
        setTimeout($053708510ab93ee9$var$runner(id), 0);
    };
}
$053708510ab93ee9$exports = {
    set: $053708510ab93ee9$var$set,
    clear: $053708510ab93ee9$var$clear
};


var $a209cfa153410f59$require$clearImmediate = $053708510ab93ee9$exports.clear;
// `clearImmediate` method
// http://w3c.github.io/setImmediate/#si-clearImmediate
$9238275af5270050$exports({
    global: true,
    bind: true,
    enumerable: true,
    forced: $2390c2ea2367eaf8$exports.clearImmediate !== $a209cfa153410f59$require$clearImmediate
}, {
    clearImmediate: $a209cfa153410f59$require$clearImmediate
});


'use strict';



var $c54ad97139296d5a$require$setTask = $053708510ab93ee9$exports.set;
var $e9e570bdf36646d5$exports = {};
'use strict';







var $e9e570bdf36646d5$var$Function = $2390c2ea2367eaf8$exports.Function;
// dirty IE9- and Bun 0.3.0- checks
var $e9e570bdf36646d5$var$WRAP = /MSIE .\./.test($50c2fc656abf0e1e$exports) || $66311f835b36ffa0$exports === 'BUN' && function() {
    var version = $2390c2ea2367eaf8$exports.Bun.version.split('.');
    return version.length < 3 || version[0] === '0' && (version[1] < 3 || version[1] === '3' && version[2] === '0');
}();
// IE9- / Bun 0.3.0- setTimeout / setInterval / setImmediate additional parameters fix
// https://html.spec.whatwg.org/multipage/timers-and-user-prompts.html#timers
// https://github.com/oven-sh/bun/issues/1633
$e9e570bdf36646d5$exports = function(scheduler, hasTimeArg) {
    var firstParamIndex = hasTimeArg ? 2 : 1;
    return $e9e570bdf36646d5$var$WRAP ? function(handler, timeout /* , ...arguments */ ) {
        var boundArgs = $a7fcaf5fee29532d$exports(arguments.length, 1) > firstParamIndex;
        var fn = $a195358de3a3707f$exports(handler) ? handler : $e9e570bdf36646d5$var$Function(handler);
        var params = boundArgs ? $862bc4037f2ad95b$exports(arguments, firstParamIndex) : [];
        var callback = boundArgs ? function() {
            $ef60a88fa6ec2ac7$exports(fn, this, params);
        } : fn;
        return hasTimeArg ? scheduler(callback, timeout) : scheduler(callback);
    } : scheduler;
};


// https://github.com/oven-sh/bun/issues/1633
var $c54ad97139296d5a$var$setImmediate = $2390c2ea2367eaf8$exports.setImmediate ? $e9e570bdf36646d5$exports($c54ad97139296d5a$require$setTask, false) : $c54ad97139296d5a$require$setTask;
// `setImmediate` method
// http://w3c.github.io/setImmediate/#si-setImmediate
$9238275af5270050$exports({
    global: true,
    bind: true,
    enumerable: true,
    forced: $2390c2ea2367eaf8$exports.setImmediate !== $c54ad97139296d5a$var$setImmediate
}, {
    setImmediate: $c54ad97139296d5a$var$setImmediate
});




var $fb0437b71d29cf93$export$402e76927ebf6a24 = [];


var $b505873c47818a37$export$63c81bd924f89474 = function() {
    return (0, $fb0437b71d29cf93$export$402e76927ebf6a24).some(function(ro) {
        return ro.activeTargets.length > 0;
    });
};



var $b719fd1725a178c9$export$8ca35300535e324d = function() {
    return (0, $fb0437b71d29cf93$export$402e76927ebf6a24).some(function(ro) {
        return ro.skippedTargets.length > 0;
    });
};


var $018dd384d8459546$var$msg = 'ResizeObserver loop completed with undelivered notifications.';
var $018dd384d8459546$export$888cb69481582149 = function() {
    var event;
    if (typeof ErrorEvent === 'function') event = new ErrorEvent('error', {
        message: $018dd384d8459546$var$msg
    });
    else {
        event = document.createEvent('Event');
        event.initEvent('error', false, false);
        event.message = $018dd384d8459546$var$msg;
    }
    window.dispatchEvent(event);
};



var $083d8ba565e03142$export$416d111b83cd1483;
(function(ResizeObserverBoxOptions) {
    ResizeObserverBoxOptions["BORDER_BOX"] = "border-box";
    ResizeObserverBoxOptions["CONTENT_BOX"] = "content-box";
    ResizeObserverBoxOptions["DEVICE_PIXEL_CONTENT_BOX"] = "device-pixel-content-box";
})($083d8ba565e03142$export$416d111b83cd1483 || ($083d8ba565e03142$export$416d111b83cd1483 = {}));


var $3b8661d127d7b35e$export$792f3d81ea979f55 = function(obj) {
    return Object.freeze(obj);
};


var $2ec57f5d1ec7829b$export$c9ad8cdf6bbd331c = function() {
    function ResizeObserverSize(inlineSize, blockSize) {
        this.inlineSize = inlineSize;
        this.blockSize = blockSize;
        (0, $3b8661d127d7b35e$export$792f3d81ea979f55)(this);
    }
    return ResizeObserverSize;
}();



var $04d118beb5764454$export$51d7a67026f4e0b7 = function() {
    function DOMRectReadOnly(x, y, width, height) {
        this.x = x;
        this.y = y;
        this.width = width;
        this.height = height;
        this.top = this.y;
        this.left = this.x;
        this.bottom = this.top + this.height;
        this.right = this.left + this.width;
        return (0, $3b8661d127d7b35e$export$792f3d81ea979f55)(this);
    }
    DOMRectReadOnly.prototype.toJSON = function() {
        var _a = this, x = _a.x, y = _a.y, top = _a.top, right = _a.right, bottom = _a.bottom, left = _a.left, width = _a.width, height = _a.height;
        return {
            x: x,
            y: y,
            top: top,
            right: right,
            bottom: bottom,
            left: left,
            width: width,
            height: height
        };
    };
    DOMRectReadOnly.fromRect = function(rectangle) {
        return new DOMRectReadOnly(rectangle.x, rectangle.y, rectangle.width, rectangle.height);
    };
    return DOMRectReadOnly;
}();


var $a3b8dfb936fe9ab6$export$165b39ed277223c2 = function(target) {
    return target instanceof SVGElement && 'getBBox' in target;
};
var $a3b8dfb936fe9ab6$export$ee695c13482bb5dd = function(target) {
    if ($a3b8dfb936fe9ab6$export$165b39ed277223c2(target)) {
        var _a = target.getBBox(), width = _a.width, height = _a.height;
        return !width && !height;
    }
    var _b = target, offsetWidth = _b.offsetWidth, offsetHeight = _b.offsetHeight;
    return !(offsetWidth || offsetHeight || target.getClientRects().length);
};
var $a3b8dfb936fe9ab6$export$45a5e7f76e0caa8d = function(obj) {
    var _a;
    if (obj instanceof Element) return true;
    var scope = (_a = obj === null || obj === void 0 ? void 0 : obj.ownerDocument) === null || _a === void 0 ? void 0 : _a.defaultView;
    return !!(scope && obj instanceof scope.Element);
};
var $a3b8dfb936fe9ab6$export$a6eb60f7e7c182ba = function(target) {
    switch(target.tagName){
        case 'INPUT':
            if (target.type !== 'image') break;
        case 'VIDEO':
        case 'AUDIO':
        case 'EMBED':
        case 'OBJECT':
        case 'CANVAS':
        case 'IFRAME':
        case 'IMG':
            return true;
    }
    return false;
};



var $a02fe118dacefcf5$export$90b4d2ff6acb88af = typeof window !== 'undefined' ? window : {};


var $47fe3b8c242a7218$var$cache = new WeakMap();
var $47fe3b8c242a7218$var$scrollRegexp = /auto|scroll/;
var $47fe3b8c242a7218$var$verticalRegexp = /^tb|vertical/;
var $47fe3b8c242a7218$var$IE = /msie|trident/i.test((0, $a02fe118dacefcf5$export$90b4d2ff6acb88af).navigator && (0, $a02fe118dacefcf5$export$90b4d2ff6acb88af).navigator.userAgent);
var $47fe3b8c242a7218$var$parseDimension = function(pixel) {
    return parseFloat(pixel || '0');
};
var $47fe3b8c242a7218$var$size = function(inlineSize, blockSize, switchSizes) {
    if (inlineSize === void 0) inlineSize = 0;
    if (blockSize === void 0) blockSize = 0;
    if (switchSizes === void 0) switchSizes = false;
    return new (0, $2ec57f5d1ec7829b$export$c9ad8cdf6bbd331c)((switchSizes ? blockSize : inlineSize) || 0, (switchSizes ? inlineSize : blockSize) || 0);
};
var $47fe3b8c242a7218$var$zeroBoxes = (0, $3b8661d127d7b35e$export$792f3d81ea979f55)({
    devicePixelContentBoxSize: $47fe3b8c242a7218$var$size(),
    borderBoxSize: $47fe3b8c242a7218$var$size(),
    contentBoxSize: $47fe3b8c242a7218$var$size(),
    contentRect: new (0, $04d118beb5764454$export$51d7a67026f4e0b7)(0, 0, 0, 0)
});
var $47fe3b8c242a7218$export$504d039a9c501c94 = function(target, forceRecalculation) {
    if (forceRecalculation === void 0) forceRecalculation = false;
    if ($47fe3b8c242a7218$var$cache.has(target) && !forceRecalculation) return $47fe3b8c242a7218$var$cache.get(target);
    if ((0, $a3b8dfb936fe9ab6$export$ee695c13482bb5dd)(target)) {
        $47fe3b8c242a7218$var$cache.set(target, $47fe3b8c242a7218$var$zeroBoxes);
        return $47fe3b8c242a7218$var$zeroBoxes;
    }
    var cs = getComputedStyle(target);
    var svg = (0, $a3b8dfb936fe9ab6$export$165b39ed277223c2)(target) && target.ownerSVGElement && target.getBBox();
    var removePadding = !$47fe3b8c242a7218$var$IE && cs.boxSizing === 'border-box';
    var switchSizes = $47fe3b8c242a7218$var$verticalRegexp.test(cs.writingMode || '');
    var canScrollVertically = !svg && $47fe3b8c242a7218$var$scrollRegexp.test(cs.overflowY || '');
    var canScrollHorizontally = !svg && $47fe3b8c242a7218$var$scrollRegexp.test(cs.overflowX || '');
    var paddingTop = svg ? 0 : $47fe3b8c242a7218$var$parseDimension(cs.paddingTop);
    var paddingRight = svg ? 0 : $47fe3b8c242a7218$var$parseDimension(cs.paddingRight);
    var paddingBottom = svg ? 0 : $47fe3b8c242a7218$var$parseDimension(cs.paddingBottom);
    var paddingLeft = svg ? 0 : $47fe3b8c242a7218$var$parseDimension(cs.paddingLeft);
    var borderTop = svg ? 0 : $47fe3b8c242a7218$var$parseDimension(cs.borderTopWidth);
    var borderRight = svg ? 0 : $47fe3b8c242a7218$var$parseDimension(cs.borderRightWidth);
    var borderBottom = svg ? 0 : $47fe3b8c242a7218$var$parseDimension(cs.borderBottomWidth);
    var borderLeft = svg ? 0 : $47fe3b8c242a7218$var$parseDimension(cs.borderLeftWidth);
    var horizontalPadding = paddingLeft + paddingRight;
    var verticalPadding = paddingTop + paddingBottom;
    var horizontalBorderArea = borderLeft + borderRight;
    var verticalBorderArea = borderTop + borderBottom;
    var horizontalScrollbarThickness = !canScrollHorizontally ? 0 : target.offsetHeight - verticalBorderArea - target.clientHeight;
    var verticalScrollbarThickness = !canScrollVertically ? 0 : target.offsetWidth - horizontalBorderArea - target.clientWidth;
    var widthReduction = removePadding ? horizontalPadding + horizontalBorderArea : 0;
    var heightReduction = removePadding ? verticalPadding + verticalBorderArea : 0;
    var contentWidth = svg ? svg.width : $47fe3b8c242a7218$var$parseDimension(cs.width) - widthReduction - verticalScrollbarThickness;
    var contentHeight = svg ? svg.height : $47fe3b8c242a7218$var$parseDimension(cs.height) - heightReduction - horizontalScrollbarThickness;
    var borderBoxWidth = contentWidth + horizontalPadding + verticalScrollbarThickness + horizontalBorderArea;
    var borderBoxHeight = contentHeight + verticalPadding + horizontalScrollbarThickness + verticalBorderArea;
    var boxes = (0, $3b8661d127d7b35e$export$792f3d81ea979f55)({
        devicePixelContentBoxSize: $47fe3b8c242a7218$var$size(Math.round(contentWidth * devicePixelRatio), Math.round(contentHeight * devicePixelRatio), switchSizes),
        borderBoxSize: $47fe3b8c242a7218$var$size(borderBoxWidth, borderBoxHeight, switchSizes),
        contentBoxSize: $47fe3b8c242a7218$var$size(contentWidth, contentHeight, switchSizes),
        contentRect: new (0, $04d118beb5764454$export$51d7a67026f4e0b7)(paddingLeft, paddingTop, contentWidth, contentHeight)
    });
    $47fe3b8c242a7218$var$cache.set(target, boxes);
    return boxes;
};
var $47fe3b8c242a7218$export$1a78030b04106bdb = function(target, observedBox, forceRecalculation) {
    var _a = $47fe3b8c242a7218$export$504d039a9c501c94(target, forceRecalculation), borderBoxSize = _a.borderBoxSize, contentBoxSize = _a.contentBoxSize, devicePixelContentBoxSize = _a.devicePixelContentBoxSize;
    switch(observedBox){
        case (0, $083d8ba565e03142$export$416d111b83cd1483).DEVICE_PIXEL_CONTENT_BOX:
            return devicePixelContentBoxSize;
        case (0, $083d8ba565e03142$export$416d111b83cd1483).BORDER_BOX:
            return borderBoxSize;
        default:
            return contentBoxSize;
    }
};



var $880f7be552fa521b$export$226159b441fc89f8 = function() {
    function ResizeObserverEntry(target) {
        var boxes = (0, $47fe3b8c242a7218$export$504d039a9c501c94)(target);
        this.target = target;
        this.contentRect = boxes.contentRect;
        this.borderBoxSize = (0, $3b8661d127d7b35e$export$792f3d81ea979f55)([
            boxes.borderBoxSize
        ]);
        this.contentBoxSize = (0, $3b8661d127d7b35e$export$792f3d81ea979f55)([
            boxes.contentBoxSize
        ]);
        this.devicePixelContentBoxSize = (0, $3b8661d127d7b35e$export$792f3d81ea979f55)([
            boxes.devicePixelContentBoxSize
        ]);
    }
    return ResizeObserverEntry;
}();



var $1080ab837a8ce7af$export$f8c8e3b5da1f41d2 = function(node) {
    if ((0, $a3b8dfb936fe9ab6$export$ee695c13482bb5dd)(node)) return Infinity;
    var depth = 0;
    var parent = node.parentNode;
    while(parent){
        depth += 1;
        parent = parent.parentNode;
    }
    return depth;
};



var $975839031603f44b$export$9cac928141e5443b = function() {
    var shallowestDepth = Infinity;
    var callbacks = [];
    (0, $fb0437b71d29cf93$export$402e76927ebf6a24).forEach(function processObserver(ro) {
        if (ro.activeTargets.length === 0) return;
        var entries = [];
        ro.activeTargets.forEach(function processTarget(ot) {
            var entry = new (0, $880f7be552fa521b$export$226159b441fc89f8)(ot.target);
            var targetDepth = (0, $1080ab837a8ce7af$export$f8c8e3b5da1f41d2)(ot.target);
            entries.push(entry);
            ot.lastReportedSize = (0, $47fe3b8c242a7218$export$1a78030b04106bdb)(ot.target, ot.observedBox);
            if (targetDepth < shallowestDepth) shallowestDepth = targetDepth;
        });
        callbacks.push(function resizeObserverCallback() {
            ro.callback.call(ro.observer, entries, ro.observer);
        });
        ro.activeTargets.splice(0, ro.activeTargets.length);
    });
    for(var _i = 0, callbacks_1 = callbacks; _i < callbacks_1.length; _i++){
        var callback = callbacks_1[_i];
        callback();
    }
    return shallowestDepth;
};




var $b434dc2f983eb805$export$9c17b8913a2a3572 = function(depth) {
    (0, $fb0437b71d29cf93$export$402e76927ebf6a24).forEach(function processObserver(ro) {
        ro.activeTargets.splice(0, ro.activeTargets.length);
        ro.skippedTargets.splice(0, ro.skippedTargets.length);
        ro.observationTargets.forEach(function processTarget(ot) {
            if (ot.isActive()) {
                if ((0, $1080ab837a8ce7af$export$f8c8e3b5da1f41d2)(ot.target) > depth) ro.activeTargets.push(ot);
                else ro.skippedTargets.push(ot);
            }
        });
    });
};


var $1f9812214ce0e741$export$e54fe5b0f43758f7 = function() {
    var depth = 0;
    (0, $b434dc2f983eb805$export$9c17b8913a2a3572)(depth);
    while((0, $b505873c47818a37$export$63c81bd924f89474)()){
        depth = (0, $975839031603f44b$export$9cac928141e5443b)();
        (0, $b434dc2f983eb805$export$9c17b8913a2a3572)(depth);
    }
    if ((0, $b719fd1725a178c9$export$8ca35300535e324d)()) (0, $018dd384d8459546$export$888cb69481582149)();
    return depth > 0;
};



var $8e996512c3b977c3$var$trigger;
var $8e996512c3b977c3$var$callbacks = [];
var $8e996512c3b977c3$var$notify = function() {
    return $8e996512c3b977c3$var$callbacks.splice(0).forEach(function(cb) {
        return cb();
    });
};
var $8e996512c3b977c3$export$4c995d4933c4abb = function(callback) {
    if (!$8e996512c3b977c3$var$trigger) {
        var toggle_1 = 0;
        var el_1 = document.createTextNode('');
        var config = {
            characterData: true
        };
        new MutationObserver(function() {
            return $8e996512c3b977c3$var$notify();
        }).observe(el_1, config);
        $8e996512c3b977c3$var$trigger = function() {
            el_1.textContent = "".concat(toggle_1 ? toggle_1-- : toggle_1++);
        };
    }
    $8e996512c3b977c3$var$callbacks.push(callback);
    $8e996512c3b977c3$var$trigger();
};


var $904178302bfd9b72$export$5755c7b572e34c6 = function(cb) {
    (0, $8e996512c3b977c3$export$4c995d4933c4abb)(function ResizeObserver() {
        requestAnimationFrame(cb);
    });
};


var $f8c8dc8f044bfd0a$var$watching = 0;
var $f8c8dc8f044bfd0a$var$isWatching = function() {
    return !!$f8c8dc8f044bfd0a$var$watching;
};
var $f8c8dc8f044bfd0a$var$CATCH_PERIOD = 250;
var $f8c8dc8f044bfd0a$var$observerConfig = {
    attributes: true,
    characterData: true,
    childList: true,
    subtree: true
};
var $f8c8dc8f044bfd0a$var$events = [
    'resize',
    'load',
    'transitionend',
    'animationend',
    'animationstart',
    'animationiteration',
    'keyup',
    'keydown',
    'mouseup',
    'mousedown',
    'mouseover',
    'mouseout',
    'blur',
    'focus'
];
var $f8c8dc8f044bfd0a$var$time = function(timeout) {
    if (timeout === void 0) timeout = 0;
    return Date.now() + timeout;
};
var $f8c8dc8f044bfd0a$var$scheduled = false;
var $f8c8dc8f044bfd0a$var$Scheduler = function() {
    function Scheduler() {
        var _this = this;
        this.stopped = true;
        this.listener = function() {
            return _this.schedule();
        };
    }
    Scheduler.prototype.run = function(timeout) {
        var _this = this;
        if (timeout === void 0) timeout = $f8c8dc8f044bfd0a$var$CATCH_PERIOD;
        if ($f8c8dc8f044bfd0a$var$scheduled) return;
        $f8c8dc8f044bfd0a$var$scheduled = true;
        var until = $f8c8dc8f044bfd0a$var$time(timeout);
        (0, $904178302bfd9b72$export$5755c7b572e34c6)(function() {
            var elementsHaveResized = false;
            try {
                elementsHaveResized = (0, $1f9812214ce0e741$export$e54fe5b0f43758f7)();
            } finally{
                $f8c8dc8f044bfd0a$var$scheduled = false;
                timeout = until - $f8c8dc8f044bfd0a$var$time();
                if (!$f8c8dc8f044bfd0a$var$isWatching()) return;
                if (elementsHaveResized) _this.run(1000);
                else if (timeout > 0) _this.run(timeout);
                else _this.start();
            }
        });
    };
    Scheduler.prototype.schedule = function() {
        this.stop();
        this.run();
    };
    Scheduler.prototype.observe = function() {
        var _this = this;
        var cb = function() {
            return _this.observer && _this.observer.observe(document.body, $f8c8dc8f044bfd0a$var$observerConfig);
        };
        document.body ? cb() : (0, $a02fe118dacefcf5$export$90b4d2ff6acb88af).addEventListener('DOMContentLoaded', cb);
    };
    Scheduler.prototype.start = function() {
        var _this = this;
        if (this.stopped) {
            this.stopped = false;
            this.observer = new MutationObserver(this.listener);
            this.observe();
            $f8c8dc8f044bfd0a$var$events.forEach(function(name) {
                return (0, $a02fe118dacefcf5$export$90b4d2ff6acb88af).addEventListener(name, _this.listener, true);
            });
        }
    };
    Scheduler.prototype.stop = function() {
        var _this = this;
        if (!this.stopped) {
            this.observer && this.observer.disconnect();
            $f8c8dc8f044bfd0a$var$events.forEach(function(name) {
                return (0, $a02fe118dacefcf5$export$90b4d2ff6acb88af).removeEventListener(name, _this.listener, true);
            });
            this.stopped = true;
        }
    };
    return Scheduler;
}();
var $f8c8dc8f044bfd0a$export$d30788f2c20241cd = new $f8c8dc8f044bfd0a$var$Scheduler();
var $f8c8dc8f044bfd0a$export$1f18a74d42722835 = function(n) {
    !$f8c8dc8f044bfd0a$var$watching && n > 0 && $f8c8dc8f044bfd0a$export$d30788f2c20241cd.start();
    $f8c8dc8f044bfd0a$var$watching += n;
    !$f8c8dc8f044bfd0a$var$watching && $f8c8dc8f044bfd0a$export$d30788f2c20241cd.stop();
};





var $62cf29df1c4ca196$var$skipNotifyOnElement = function(target) {
    return !(0, $a3b8dfb936fe9ab6$export$165b39ed277223c2)(target) && !(0, $a3b8dfb936fe9ab6$export$a6eb60f7e7c182ba)(target) && getComputedStyle(target).display === 'inline';
};
var $62cf29df1c4ca196$export$fea412043713122 = function() {
    function ResizeObservation(target, observedBox) {
        this.target = target;
        this.observedBox = observedBox || (0, $083d8ba565e03142$export$416d111b83cd1483).CONTENT_BOX;
        this.lastReportedSize = {
            inlineSize: 0,
            blockSize: 0
        };
    }
    ResizeObservation.prototype.isActive = function() {
        var size = (0, $47fe3b8c242a7218$export$1a78030b04106bdb)(this.target, this.observedBox, true);
        if ($62cf29df1c4ca196$var$skipNotifyOnElement(this.target)) this.lastReportedSize = size;
        if (this.lastReportedSize.inlineSize !== size.inlineSize || this.lastReportedSize.blockSize !== size.blockSize) return true;
        return false;
    };
    return ResizeObservation;
}();


var $76daed03df3f4ab9$export$d86966e6e4bc97e1 = function() {
    function ResizeObserverDetail(resizeObserver, callback) {
        this.activeTargets = [];
        this.skippedTargets = [];
        this.observationTargets = [];
        this.observer = resizeObserver;
        this.callback = callback;
    }
    return ResizeObserverDetail;
}();



var $9706c7b9e61d8ea2$var$observerMap = new WeakMap();
var $9706c7b9e61d8ea2$var$getObservationIndex = function(observationTargets, target) {
    for(var i = 0; i < observationTargets.length; i += 1){
        if (observationTargets[i].target === target) return i;
    }
    return -1;
};
var $9706c7b9e61d8ea2$export$ed99c5bafbaf8300 = function() {
    function ResizeObserverController() {}
    ResizeObserverController.connect = function(resizeObserver, callback) {
        var detail = new (0, $76daed03df3f4ab9$export$d86966e6e4bc97e1)(resizeObserver, callback);
        $9706c7b9e61d8ea2$var$observerMap.set(resizeObserver, detail);
    };
    ResizeObserverController.observe = function(resizeObserver, target, options) {
        var detail = $9706c7b9e61d8ea2$var$observerMap.get(resizeObserver);
        var firstObservation = detail.observationTargets.length === 0;
        if ($9706c7b9e61d8ea2$var$getObservationIndex(detail.observationTargets, target) < 0) {
            firstObservation && (0, $fb0437b71d29cf93$export$402e76927ebf6a24).push(detail);
            detail.observationTargets.push(new (0, $62cf29df1c4ca196$export$fea412043713122)(target, options && options.box));
            (0, $f8c8dc8f044bfd0a$export$1f18a74d42722835)(1);
            (0, $f8c8dc8f044bfd0a$export$d30788f2c20241cd).schedule();
        }
    };
    ResizeObserverController.unobserve = function(resizeObserver, target) {
        var detail = $9706c7b9e61d8ea2$var$observerMap.get(resizeObserver);
        var index = $9706c7b9e61d8ea2$var$getObservationIndex(detail.observationTargets, target);
        var lastObservation = detail.observationTargets.length === 1;
        if (index >= 0) {
            lastObservation && (0, $fb0437b71d29cf93$export$402e76927ebf6a24).splice((0, $fb0437b71d29cf93$export$402e76927ebf6a24).indexOf(detail), 1);
            detail.observationTargets.splice(index, 1);
            (0, $f8c8dc8f044bfd0a$export$1f18a74d42722835)(-1);
        }
    };
    ResizeObserverController.disconnect = function(resizeObserver) {
        var _this = this;
        var detail = $9706c7b9e61d8ea2$var$observerMap.get(resizeObserver);
        detail.observationTargets.slice().forEach(function(ot) {
            return _this.unobserve(resizeObserver, ot.target);
        });
        detail.activeTargets.splice(0, detail.activeTargets.length);
    };
    return ResizeObserverController;
}();



var $a00bc23a45de1f93$export$9caf76241ca21a11 = function() {
    function ResizeObserver(callback) {
        if (arguments.length === 0) throw new TypeError("Failed to construct 'ResizeObserver': 1 argument required, but only 0 present.");
        if (typeof callback !== 'function') throw new TypeError("Failed to construct 'ResizeObserver': The callback provided as parameter 1 is not a function.");
        (0, $9706c7b9e61d8ea2$export$ed99c5bafbaf8300).connect(this, callback);
    }
    ResizeObserver.prototype.observe = function(target, options) {
        if (arguments.length === 0) throw new TypeError("Failed to execute 'observe' on 'ResizeObserver': 1 argument required, but only 0 present.");
        if (!(0, $a3b8dfb936fe9ab6$export$45a5e7f76e0caa8d)(target)) throw new TypeError("Failed to execute 'observe' on 'ResizeObserver': parameter 1 is not of type 'Element");
        (0, $9706c7b9e61d8ea2$export$ed99c5bafbaf8300).observe(this, target, options);
    };
    ResizeObserver.prototype.unobserve = function(target) {
        if (arguments.length === 0) throw new TypeError("Failed to execute 'unobserve' on 'ResizeObserver': 1 argument required, but only 0 present.");
        if (!(0, $a3b8dfb936fe9ab6$export$45a5e7f76e0caa8d)(target)) throw new TypeError("Failed to execute 'unobserve' on 'ResizeObserver': parameter 1 is not of type 'Element");
        (0, $9706c7b9e61d8ea2$export$ed99c5bafbaf8300).unobserve(this, target);
    };
    ResizeObserver.prototype.disconnect = function() {
        (0, $9706c7b9e61d8ea2$export$ed99c5bafbaf8300).disconnect(this);
    };
    ResizeObserver.toString = function() {
        return 'function ResizeObserver () { [polyfill code] }';
    };
    return ResizeObserver;
}();






var $5878bf5e4838ee31$exports = {};
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $5878bf5e4838ee31$var$runtime = function(exports) {
    "use strict";
    var Op = Object.prototype;
    var hasOwn = Op.hasOwnProperty;
    var defineProperty = Object.defineProperty || function(obj, key, desc) {
        obj[key] = desc.value;
    };
    var undefined; // More compressible than void 0.
    var $Symbol = typeof Symbol === "function" ? Symbol : {};
    var iteratorSymbol = $Symbol.iterator || "@@iterator";
    var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
    var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
    function define(obj, key, value) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
        return obj[key];
    }
    try {
        // IE 8 has a broken Object.defineProperty that only works on DOM objects.
        define({}, "");
    } catch (err) {
        define = function(obj, key, value) {
            return obj[key] = value;
        };
    }
    function wrap(innerFn, outerFn, self, tryLocsList) {
        // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
        var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
        var generator = Object.create(protoGenerator.prototype);
        var context = new Context(tryLocsList || []);
        // The ._invoke method unifies the implementations of the .next,
        // .throw, and .return methods.
        defineProperty(generator, "_invoke", {
            value: makeInvokeMethod(innerFn, self, context)
        });
        return generator;
    }
    exports.wrap = wrap;
    // Try/catch helper to minimize deoptimizations. Returns a completion
    // record like context.tryEntries[i].completion. This interface could
    // have been (and was previously) designed to take a closure to be
    // invoked without arguments, but in all the cases we care about we
    // already have an existing method we want to call, so there's no need
    // to create a new function object. We can even get away with assuming
    // the method takes exactly one argument, since that happens to be true
    // in every case, so we don't have to touch the arguments object. The
    // only additional allocation required is the completion record, which
    // has a stable shape and so hopefully should be cheap to allocate.
    function tryCatch(fn, obj, arg) {
        try {
            return {
                type: "normal",
                arg: fn.call(obj, arg)
            };
        } catch (err) {
            return {
                type: "throw",
                arg: err
            };
        }
    }
    var GenStateSuspendedStart = "suspendedStart";
    var GenStateSuspendedYield = "suspendedYield";
    var GenStateExecuting = "executing";
    var GenStateCompleted = "completed";
    // Returning this object from the innerFn has the same effect as
    // breaking out of the dispatch switch statement.
    var ContinueSentinel = {};
    // Dummy constructor functions that we use as the .constructor and
    // .constructor.prototype properties for functions that return Generator
    // objects. For full spec compliance, you may wish to configure your
    // minifier not to mangle the names of these two functions.
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    // This is a polyfill for %IteratorPrototype% for environments that
    // don't natively support it.
    var IteratorPrototype = {};
    define(IteratorPrototype, iteratorSymbol, function() {
        return this;
    });
    var getProto = Object.getPrototypeOf;
    var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
    if (NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
    GeneratorFunction.prototype = GeneratorFunctionPrototype;
    defineProperty(Gp, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: true
    });
    defineProperty(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: true
    });
    GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction");
    // Helper for defining the .next, .throw, and .return methods of the
    // Iterator interface in terms of a single ._invoke method.
    function defineIteratorMethods(prototype) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(method) {
            define(prototype, method, function(arg) {
                return this._invoke(method, arg);
            });
        });
    }
    exports.isGeneratorFunction = function(genFun) {
        var ctor = typeof genFun === "function" && genFun.constructor;
        return ctor ? ctor === GeneratorFunction || // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction" : false;
    };
    exports.mark = function(genFun) {
        if (Object.setPrototypeOf) Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
        else {
            genFun.__proto__ = GeneratorFunctionPrototype;
            define(genFun, toStringTagSymbol, "GeneratorFunction");
        }
        genFun.prototype = Object.create(Gp);
        return genFun;
    };
    // Within the body of any async function, `await x` is transformed to
    // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
    // `hasOwn.call(value, "__await")` to determine if the yielded value is
    // meant to be awaited.
    exports.awrap = function(arg) {
        return {
            __await: arg
        };
    };
    function AsyncIterator(generator, PromiseImpl) {
        function invoke(method, arg, resolve, reject) {
            var record = tryCatch(generator[method], generator, arg);
            if (record.type === "throw") reject(record.arg);
            else {
                var result = record.arg;
                var value = result.value;
                if (value && typeof value === "object" && hasOwn.call(value, "__await")) return PromiseImpl.resolve(value.__await).then(function(value) {
                    invoke("next", value, resolve, reject);
                }, function(err) {
                    invoke("throw", err, resolve, reject);
                });
                return PromiseImpl.resolve(value).then(function(unwrapped) {
                    // When a yielded Promise is resolved, its final value becomes
                    // the .value of the Promise<{value,done}> result for the
                    // current iteration.
                    result.value = unwrapped;
                    resolve(result);
                }, function(error) {
                    // If a rejected Promise was yielded, throw the rejection back
                    // into the async generator function so it can be handled there.
                    return invoke("throw", error, resolve, reject);
                });
            }
        }
        var previousPromise;
        function enqueue(method, arg) {
            function callInvokeWithMethodAndArg() {
                return new PromiseImpl(function(resolve, reject) {
                    invoke(method, arg, resolve, reject);
                });
            }
            return previousPromise = // If enqueue has been called before, then we want to wait until
            // all previous Promises have been resolved before calling invoke,
            // so that results are always delivered in the correct order. If
            // enqueue has not been called before, then it is important to
            // call invoke immediately, without waiting on a callback to fire,
            // so that the async generator function has the opportunity to do
            // any necessary setup in a predictable way. This predictability
            // is why the Promise constructor synchronously invokes its
            // executor callback, and why async functions synchronously
            // execute code before the first await. Since we implement simple
            // async functions in terms of async generators, it is especially
            // important to get this right, even though it requires care.
            previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, // Avoid propagating failures to Promises returned by later
            // invocations of the iterator.
            callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
        }
        // Define the unified helper method that is used to implement .next,
        // .throw, and .return (see defineIteratorMethods).
        defineProperty(this, "_invoke", {
            value: enqueue
        });
    }
    defineIteratorMethods(AsyncIterator.prototype);
    define(AsyncIterator.prototype, asyncIteratorSymbol, function() {
        return this;
    });
    exports.AsyncIterator = AsyncIterator;
    // Note that simple async functions are implemented on top of
    // AsyncIterator objects; they just return a Promise for the value of
    // the final result produced by the iterator.
    exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
        if (PromiseImpl === void 0) PromiseImpl = Promise;
        var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
        return exports.isGeneratorFunction(outerFn) ? iter // If outerFn is a generator, return the full iterator.
         : iter.next().then(function(result) {
            return result.done ? result.value : iter.next();
        });
    };
    function makeInvokeMethod(innerFn, self, context) {
        var state = GenStateSuspendedStart;
        return function invoke(method, arg) {
            if (state === GenStateExecuting) throw new Error("Generator is already running");
            if (state === GenStateCompleted) {
                if (method === "throw") throw arg;
                // Be forgiving, per GeneratorResume behavior specified since ES2015:
                // ES2015 spec, step 3: https://262.ecma-international.org/6.0/#sec-generatorresume
                // Latest spec, step 2: https://tc39.es/ecma262/#sec-generatorresume
                return doneResult();
            }
            context.method = method;
            context.arg = arg;
            while(true){
                var delegate = context.delegate;
                if (delegate) {
                    var delegateResult = maybeInvokeDelegate(delegate, context);
                    if (delegateResult) {
                        if (delegateResult === ContinueSentinel) continue;
                        return delegateResult;
                    }
                }
                if (context.method === "next") // Setting context._sent for legacy support of Babel's
                // function.sent implementation.
                context.sent = context._sent = context.arg;
                else if (context.method === "throw") {
                    if (state === GenStateSuspendedStart) {
                        state = GenStateCompleted;
                        throw context.arg;
                    }
                    context.dispatchException(context.arg);
                } else if (context.method === "return") context.abrupt("return", context.arg);
                state = GenStateExecuting;
                var record = tryCatch(innerFn, self, context);
                if (record.type === "normal") {
                    // If an exception is thrown from innerFn, we leave state ===
                    // GenStateExecuting and loop back for another invocation.
                    state = context.done ? GenStateCompleted : GenStateSuspendedYield;
                    if (record.arg === ContinueSentinel) continue;
                    return {
                        value: record.arg,
                        done: context.done
                    };
                } else if (record.type === "throw") {
                    state = GenStateCompleted;
                    // Dispatch the exception by looping back around to the
                    // context.dispatchException(context.arg) call above.
                    context.method = "throw";
                    context.arg = record.arg;
                }
            }
        };
    }
    // Call delegate.iterator[context.method](context.arg) and handle the
    // result, either by returning a { value, done } result from the
    // delegate iterator, or by modifying context.method and context.arg,
    // setting context.delegate to null, and returning the ContinueSentinel.
    function maybeInvokeDelegate(delegate, context) {
        var methodName = context.method;
        var method = delegate.iterator[methodName];
        if (method === undefined) {
            // A .throw or .return when the delegate iterator has no .throw
            // method, or a missing .next method, always terminate the
            // yield* loop.
            context.delegate = null;
            // Note: ["return"] must be used for ES3 parsing compatibility.
            if (methodName === "throw" && delegate.iterator["return"]) {
                // If the delegate iterator has a return method, give it a
                // chance to clean up.
                context.method = "return";
                context.arg = undefined;
                maybeInvokeDelegate(delegate, context);
                if (context.method === "throw") // If maybeInvokeDelegate(context) changed context.method from
                // "return" to "throw", let that override the TypeError below.
                return ContinueSentinel;
            }
            if (methodName !== "return") {
                context.method = "throw";
                context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method");
            }
            return ContinueSentinel;
        }
        var record = tryCatch(method, delegate.iterator, context.arg);
        if (record.type === "throw") {
            context.method = "throw";
            context.arg = record.arg;
            context.delegate = null;
            return ContinueSentinel;
        }
        var info = record.arg;
        if (!info) {
            context.method = "throw";
            context.arg = new TypeError("iterator result is not an object");
            context.delegate = null;
            return ContinueSentinel;
        }
        if (info.done) {
            // Assign the result of the finished delegate to the temporary
            // variable specified by delegate.resultName (see delegateYield).
            context[delegate.resultName] = info.value;
            // Resume execution at the desired location (see delegateYield).
            context.next = delegate.nextLoc;
            // If context.method was "throw" but the delegate handled the
            // exception, let the outer generator proceed normally. If
            // context.method was "next", forget context.arg since it has been
            // "consumed" by the delegate iterator. If context.method was
            // "return", allow the original .return call to continue in the
            // outer generator.
            if (context.method !== "return") {
                context.method = "next";
                context.arg = undefined;
            }
        } else // Re-yield the result returned by the delegate method.
        return info;
        // The delegate iterator is finished, so forget it and continue with
        // the outer generator.
        context.delegate = null;
        return ContinueSentinel;
    }
    // Define Generator.prototype.{next,throw,return} in terms of the
    // unified ._invoke helper method.
    defineIteratorMethods(Gp);
    define(Gp, toStringTagSymbol, "Generator");
    // A Generator should always return itself as the iterator object when the
    // @@iterator function is called on it. Some browsers' implementations of the
    // iterator prototype chain incorrectly implement this, causing the Generator
    // object to not be returned from this call. This ensures that doesn't happen.
    // See https://github.com/facebook/regenerator/issues/274 for more details.
    define(Gp, iteratorSymbol, function() {
        return this;
    });
    define(Gp, "toString", function() {
        return "[object Generator]";
    });
    function pushTryEntry(locs) {
        var entry = {
            tryLoc: locs[0]
        };
        if (1 in locs) entry.catchLoc = locs[1];
        if (2 in locs) {
            entry.finallyLoc = locs[2];
            entry.afterLoc = locs[3];
        }
        this.tryEntries.push(entry);
    }
    function resetTryEntry(entry) {
        var record = entry.completion || {};
        record.type = "normal";
        delete record.arg;
        entry.completion = record;
    }
    function Context(tryLocsList) {
        // The root entry object (effectively a try statement without a catch
        // or a finally block) gives us a place to store values thrown from
        // locations where there is no enclosing try statement.
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ];
        tryLocsList.forEach(pushTryEntry, this);
        this.reset(true);
    }
    exports.keys = function(val) {
        var object = Object(val);
        var keys = [];
        for(var key in object)keys.push(key);
        keys.reverse();
        // Rather than returning an object with a next method, we keep
        // things simple and return the next function itself.
        return function next() {
            while(keys.length){
                var key = keys.pop();
                if (key in object) {
                    next.value = key;
                    next.done = false;
                    return next;
                }
            }
            // To avoid creating an additional object, we just hang the .value
            // and .done properties off the next function object itself. This
            // also ensures that the minifier will not anonymize the function.
            next.done = true;
            return next;
        };
    };
    function values(iterable) {
        if (iterable != null) {
            var iteratorMethod = iterable[iteratorSymbol];
            if (iteratorMethod) return iteratorMethod.call(iterable);
            if (typeof iterable.next === "function") return iterable;
            if (!isNaN(iterable.length)) {
                var i = -1, next = function next() {
                    while(++i < iterable.length)if (hasOwn.call(iterable, i)) {
                        next.value = iterable[i];
                        next.done = false;
                        return next;
                    }
                    next.value = undefined;
                    next.done = true;
                    return next;
                };
                return next.next = next;
            }
        }
        throw new TypeError(typeof iterable + " is not iterable");
    }
    exports.values = values;
    function doneResult() {
        return {
            value: undefined,
            done: true
        };
    }
    Context.prototype = {
        constructor: Context,
        reset: function(skipTempReset) {
            this.prev = 0;
            this.next = 0;
            // Resetting context._sent for legacy support of Babel's
            // function.sent implementation.
            this.sent = this._sent = undefined;
            this.done = false;
            this.delegate = null;
            this.method = "next";
            this.arg = undefined;
            this.tryEntries.forEach(resetTryEntry);
            if (!skipTempReset) {
                for(var name in this)// Not sure about the optimal order of these conditions:
                if (name.charAt(0) === "t" && hasOwn.call(this, name) && !isNaN(+name.slice(1))) this[name] = undefined;
            }
        },
        stop: function() {
            this.done = true;
            var rootEntry = this.tryEntries[0];
            var rootRecord = rootEntry.completion;
            if (rootRecord.type === "throw") throw rootRecord.arg;
            return this.rval;
        },
        dispatchException: function(exception) {
            if (this.done) throw exception;
            var context = this;
            function handle(loc, caught) {
                record.type = "throw";
                record.arg = exception;
                context.next = loc;
                if (caught) {
                    // If the dispatched exception was caught by a catch block,
                    // then let that catch block handle the exception normally.
                    context.method = "next";
                    context.arg = undefined;
                }
                return !!caught;
            }
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                var record = entry.completion;
                if (entry.tryLoc === "root") // Exception thrown outside of any try block that could handle
                // it, so set the completion value of the entire function to
                // throw the exception.
                return handle("end");
                if (entry.tryLoc <= this.prev) {
                    var hasCatch = hasOwn.call(entry, "catchLoc");
                    var hasFinally = hasOwn.call(entry, "finallyLoc");
                    if (hasCatch && hasFinally) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, true);
                        else if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else if (hasCatch) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, true);
                    } else if (hasFinally) {
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else throw new Error("try statement without catch or finally");
                }
            }
        },
        abrupt: function(type, arg) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
                    var finallyEntry = entry;
                    break;
                }
            }
            if (finallyEntry && (type === "break" || type === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) // Ignore the finally entry if control is not jumping to a
            // location outside the try/catch block.
            finallyEntry = null;
            var record = finallyEntry ? finallyEntry.completion : {};
            record.type = type;
            record.arg = arg;
            if (finallyEntry) {
                this.method = "next";
                this.next = finallyEntry.finallyLoc;
                return ContinueSentinel;
            }
            return this.complete(record);
        },
        complete: function(record, afterLoc) {
            if (record.type === "throw") throw record.arg;
            if (record.type === "break" || record.type === "continue") this.next = record.arg;
            else if (record.type === "return") {
                this.rval = this.arg = record.arg;
                this.method = "return";
                this.next = "end";
            } else if (record.type === "normal" && afterLoc) this.next = afterLoc;
            return ContinueSentinel;
        },
        finish: function(finallyLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.finallyLoc === finallyLoc) {
                    this.complete(entry.completion, entry.afterLoc);
                    resetTryEntry(entry);
                    return ContinueSentinel;
                }
            }
        },
        "catch": function(tryLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc === tryLoc) {
                    var record = entry.completion;
                    if (record.type === "throw") {
                        var thrown = record.arg;
                        resetTryEntry(entry);
                    }
                    return thrown;
                }
            }
            // The context.catch method must only be called with a location
            // argument that corresponds to a known catch block.
            throw new Error("illegal catch attempt");
        },
        delegateYield: function(iterable, resultName, nextLoc) {
            this.delegate = {
                iterator: values(iterable),
                resultName: resultName,
                nextLoc: nextLoc
            };
            if (this.method === "next") // Deliberately forget the last sent value so that we don't
            // accidentally pass it on to the delegate.
            this.arg = undefined;
            return ContinueSentinel;
        }
    };
    // Regardless of whether this script is executing as a CommonJS module
    // or not, return the runtime object so that we can declare the variable
    // regeneratorRuntime in the outer scope, which allows this module to be
    // injected easily by `bin/regenerator --include-runtime script.js`.
    return exports;
}(// If this script is executing as a CommonJS module, use module.exports
// as the regeneratorRuntime namespace. Otherwise create a new empty
// object. Either way, the resulting object will be used to initialize
// the regeneratorRuntime variable at the top of this file.
(0, $5878bf5e4838ee31$exports));
try {
    regeneratorRuntime = $5878bf5e4838ee31$var$runtime;
} catch (accidentalStrictMode) {
    // This module should not be running in strict mode, so the above
    // assignment should always work unless something is misconfigured. Just
    // in case runtime.js accidentally runs in strict mode, in modern engines
    // we can explicitly access globalThis. In older engines we can escape
    // strict mode using a global Function call. This could conceivably fail
    // if a Content Security Policy forbids using Function, but in that case
    // the proper solution is to fix the accidental strict mode problem. If
    // you've misconfigured your bundler to force strict mode and applied a
    // CSP to forbid Function, and you're not willing to fix either of those
    // problems, please detail your unique predicament in a GitHub issue.
    if (typeof globalThis === "object") globalThis.regeneratorRuntime = $5878bf5e4838ee31$var$runtime;
    else Function("r", "regeneratorRuntime = r")($5878bf5e4838ee31$var$runtime);
}


// eslint-disable-next-line @atlassian/ssr-linting/no-dom-globals-in-module-scope
if (!window.ResizeObserver) window.ResizeObserver = (0, $a00bc23a45de1f93$export$9caf76241ca21a11);


//# sourceMappingURL=babel.polyfills.9f10e929.js.map
